var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCenterMobileFullMacbook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 218,
    viewBox: "0 0 360 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_638)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.973 204.142V202.781H0V204.142C0 208.121 0 210.111 0.774369 211.631C1.45552 212.968 2.5424 214.054 3.87925 214.736C5.39903 215.51 7.38854 215.51 11.3676 215.51H348.605C352.584 215.51 354.574 215.51 356.094 214.736C357.43 214.054 358.517 212.968 359.198 211.631C359.973 210.111 359.973 208.121 359.973 204.142Z",
    fill: "url(#paint0_linear_1_638)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.251 216.398C339.724 216.28 340.04 215.757 340.139 215.51H316.604C316.703 215.757 317.019 216.28 317.492 216.398C317.542 216.743 317.759 217.434 318.232 217.434H338.511C338.984 217.434 339.201 216.743 339.251 216.398Z",
    fill: "url(#paint1_linear_1_638)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.229 216.518V216.472H317.505C317.572 216.833 317.791 217.434 318.233 217.434H338.511C338.934 217.434 339.153 216.882 339.229 216.518Z",
    fill: "url(#paint2_linear_1_638)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.614 216.855C317.562 216.721 317.526 216.585 317.505 216.472H339.229V216.518C339.208 216.621 339.174 216.739 339.129 216.855H317.614Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1843 216.398C42.658 216.28 42.9737 215.757 43.0724 215.51H19.538C19.6367 215.757 19.9524 216.28 20.4261 216.398C20.4754 216.743 20.6925 217.434 21.1662 217.434H41.4442C41.9179 217.434 42.135 216.743 42.1843 216.398Z",
    fill: "url(#paint3_linear_1_638)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1629 216.518V216.472H20.4383C20.5058 216.833 20.7244 217.434 21.1661 217.434H41.4442C41.8677 217.434 42.0861 216.882 42.1629 216.518Z",
    fill: "url(#paint4_linear_1_638)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1629 216.518V216.472H20.4384C20.4595 216.585 20.4953 216.721 20.5482 216.855H42.0623C42.1081 216.739 42.1412 216.621 42.1629 216.518Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.607 202.781H211.218C211.218 205.478 209.031 207.665 206.333 207.665H153.492C150.794 207.665 148.607 205.478 148.607 202.781Z",
    fill: "url(#paint5_linear_1_638)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.067 202.929C210.989 205.476 208.899 207.517 206.333 207.517H153.492C150.925 207.517 148.836 205.476 148.757 202.929H211.067Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.29603
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.998,
    y: 202.781,
    width: 23.9784,
    height: 9.769,
    fill: "url(#paint6_linear_1_638)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.8665,
    height: 9.769,
    transform: "matrix(-1 0 0 1 25.0146 202.781)",
    fill: "url(#paint7_linear_1_638)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.016 202.781H356.864V208.735C356.864 210.024 355.819 211.069 354.529 211.069C353.694 211.069 353.016 210.392 353.016 209.556V202.781Z",
    fill: "#D2D2DA"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1_638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.06863 202.781H2.8123V209.094C2.8123 210.185 3.69688 211.069 4.78805 211.069C5.4953 211.069 6.06863 210.496 6.06863 209.789V202.781Z",
    fill: "#D2D2DA"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M180.134 0.59201H319.269C323.846 0.59201 327.557 4.30305 327.557 8.88086V202.189H180.134H179.986H32.5634V8.88086C32.5634 4.30305 36.2744 0.59201 40.8522 0.59201H179.986H180.134Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.269 1.18407H40.8522C36.6014 1.18407 33.1554 4.63004 33.1554 8.88086V201.597H326.965V8.88086C326.965 4.63004 323.519 1.18407 319.269 1.18407ZM319.269 0.59201H40.8522C36.2744 0.59201 32.5634 4.30305 32.5634 8.88086V202.189H327.557V8.88086C327.557 4.30305 323.846 0.59201 319.269 0.59201Z",
    fill: "#201F24"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.15 202.781H31.9713V8.88091C31.9713 3.97612 35.9474 0 40.8522 0H319.269C324.173 0 328.15 3.97612 328.15 8.88091V202.781ZM319.269 0.592061H40.8522C36.2744 0.592061 32.5633 4.3031 32.5633 8.88091V202.189H327.558V8.88091C327.558 4.3031 323.846 0.592061 319.269 0.592061Z",
    fill: "#7D7D7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4059 194.492H326.67V200.116C326.67 200.77 326.139 201.3 325.486 201.3H34.59C33.9361 201.3 33.4059 200.77 33.4059 200.116V194.492Z",
    fill: "url(#paint8_linear_1_638)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.856 9.47254C36.856 7.18364 38.7116 5.32812 41.0005 5.32812H318.973C321.262 5.32812 323.117 7.18365 323.117 9.47255V191.235H36.856V9.47254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.452 6.06855C197.452 5.32848 198.34 5.32848 198.784 5.32848H161.188C161.633 5.32848 162.521 5.32848 162.521 6.06855V8.88084C162.521 10.1888 163.581 11.2491 164.889 11.2491H195.084C196.392 11.2491 197.452 10.1888 197.452 8.88084V6.06855Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.986,
    cy: 7.13158,
    r: 1.1187,
    fill: "#0F0F0F",
    stroke: "#151515",
    strokeWidth: 0.0771518
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.871,
    cy: 7.40164,
    r: 0.270031,
    fill: "#16181E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.871,
    cy: 7.01593,
    r: 0.270031,
    fill: "#0A0B0D"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 179.986,
    cy: 7.13165,
    r: 0.385759,
    fill: "#1F2531"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1_638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.471 181.819V164.86H203.526V181.819H155.471Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.181 160.545V108.238H190.819V160.545H168.181Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.89 170.448V170.762L169.898 170.759V173.532H168.578V170.448C168.578 170.274 168.647 170.107 168.77 169.984C168.893 169.861 169.06 169.792 169.234 169.792C169.408 169.792 169.575 169.861 169.698 169.984C169.821 170.107 169.89 170.274 169.89 170.448Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.011 170.461L174.018 170.57V173.532H172.694V170.455C172.707 170.291 172.781 170.137 172.902 170.024C173.024 169.909 173.185 169.846 173.352 169.846C173.52 169.846 173.681 169.909 173.803 170.024C173.926 170.138 174 170.294 174.011 170.461Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.112 170.461L178.119 170.57V173.532H176.795V170.455C176.808 170.291 176.882 170.137 177.003 170.024C177.125 169.909 177.286 169.846 177.453 169.846C177.621 169.846 177.782 169.909 177.904 170.024C178.027 170.138 178.101 170.294 178.112 170.461Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.228 170.448V170.763L182.236 170.759V173.532H180.916V170.448C180.916 170.274 180.985 170.107 181.108 169.984C181.231 169.861 181.398 169.792 181.572 169.792C181.746 169.792 181.913 169.861 182.036 169.984C182.159 170.107 182.228 170.274 182.228 170.448Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.89 176.654V176.774L169.898 176.778V179.745H168.578V176.654C168.578 176.48 168.647 176.313 168.77 176.19C168.893 176.067 169.06 175.998 169.234 175.998C169.408 175.998 169.575 176.067 169.698 176.19C169.821 176.313 169.89 176.48 169.89 176.654Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.011 176.667L174.018 176.776V179.745H172.694V176.661C172.707 176.496 172.781 176.342 172.902 176.229C173.024 176.115 173.185 176.052 173.352 176.052C173.52 176.052 173.681 176.115 173.803 176.229C173.926 176.344 174 176.5 174.011 176.667Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.112 176.667L178.119 176.776V179.745H176.795V176.661C176.808 176.496 176.882 176.342 177.003 176.229C177.125 176.115 177.286 176.052 177.453 176.052C177.621 176.052 177.782 176.115 177.904 176.229C178.027 176.344 178.101 176.5 178.112 176.667Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.228 176.654V176.774L182.236 176.778V179.745H180.916V176.654C180.916 176.48 180.985 176.313 181.108 176.19C181.231 176.067 181.398 175.998 181.572 175.998C181.746 175.998 181.913 176.067 182.036 176.19C182.159 176.313 182.228 176.48 182.228 176.654Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.461 170.448V170.763L186.469 170.759V173.532H185.149V170.448C185.149 170.274 185.218 170.107 185.341 169.984C185.464 169.861 185.631 169.792 185.805 169.792C185.979 169.792 186.146 169.861 186.269 169.984C186.392 170.107 186.461 170.274 186.461 170.448Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.597 170.455V173.532H189.281V170.455C189.293 170.291 189.367 170.137 189.488 170.024C189.61 169.909 189.772 169.846 189.939 169.846C190.106 169.846 190.268 169.909 190.39 170.024C190.511 170.137 190.585 170.291 190.597 170.455Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.461 176.654V176.774L186.469 176.778V179.745H185.149V176.654C185.149 176.48 185.218 176.313 185.341 176.19C185.464 176.067 185.631 175.998 185.805 175.998C185.979 175.998 186.146 176.067 186.269 176.19C186.392 176.313 186.461 176.48 186.461 176.654Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.39 176.229C190.511 176.342 190.585 176.496 190.597 176.661V179.745H189.281V176.661C189.293 176.496 189.367 176.342 189.488 176.229C189.61 176.115 189.772 176.052 189.939 176.052C190.106 176.052 190.268 176.115 190.39 176.229Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.471 160.545V107.391H167.199V160.545H159.471Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.834 110.778V109.1H163.859V110.778H162.834Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.834 113.834V112.156H163.859V113.834H162.834Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.834 116.89V115.213H163.859V116.89H162.834Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.834 119.947V118.269H163.859V119.947H162.834Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.834 123.003V121.325H163.859V123.003H162.834Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.834 126.059V124.382H163.859V126.059H162.834Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.834 129.12V127.442H163.859V129.12H162.834Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.834 132.176V130.498H163.859V132.176H162.834Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.834 138.289V136.611H163.859V138.289H162.834Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.834 141.345V139.667H163.859V141.345H162.834Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.834 144.401V142.724H163.859V144.401H162.834Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.834 147.458V145.78H163.859V147.458H162.834Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.834 150.518V148.84H163.859V150.518H162.834Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.834 153.574V151.897H163.859V153.574H162.834Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.834 156.631V154.953H163.859V156.631H162.834Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.834 159.687V158.009H163.859V159.687H162.834Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.834 135.232V133.555H163.859V135.232H162.834Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.471 163.901V109.1H158.488V163.901H155.471Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.733 111.811V110.133H157.234V111.811H156.733Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.733 114.867V113.189H157.234V114.867H156.733Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.733 117.923V116.246H157.234V117.923H156.733Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.733 120.98V119.302H157.234V120.98H156.733Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.733 124.036V122.358H157.234V124.036H156.733Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.733 127.092V125.415H157.234V127.092H156.733Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.733 130.149V128.471H157.234V130.149H156.733Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.733 133.209V131.531H157.234V133.209H156.733Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.733 139.322V137.644H157.234V139.322H156.733Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.733 142.378V140.7H157.234V142.378H156.733Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.733 145.434V143.757H157.234V145.434H156.733Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.733 148.491V146.813H157.234V148.491H156.733Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.733 151.547V149.869H157.234V151.547H156.733Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.733 154.607V152.93H157.234V154.607H156.733Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.733 157.664V155.986H157.234V157.664H156.733Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.733 160.72V159.042H157.234V160.72H156.733Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.733 136.265V134.588H157.234V136.265H156.733Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.529 107.391V160.545H191.801V107.391H199.529Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.141 110.778V109.1H196.166V110.778H195.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.141 113.834V112.156H196.166V113.834H195.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.141 116.89V115.213H196.166V116.89H195.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.141 119.947V118.269H196.166V119.947H195.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.141 123.003V121.325H196.166V123.003H195.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.141 126.059V124.382H196.166V126.059H195.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.141 129.12V127.442H196.166V129.12H195.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.141 132.176V130.498H196.166V132.176H195.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.141 138.289V136.611H196.166V138.289H195.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.141 141.345V139.667H196.166V141.345H195.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.141 144.401V142.724H196.166V144.401H195.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.141 147.458V145.78H196.166V147.458H195.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.141 150.518V148.84H196.166V150.518H195.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.141 153.574V151.897H196.166V153.574H195.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.141 156.631V154.953H196.166V156.631H195.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.141 159.687V158.009H196.166V159.687H195.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.141 135.232V133.555H196.166V135.232H195.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.525 109.1V163.901H200.508V109.1H203.525Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.77 111.811V110.133H202.271V111.811H201.77Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.77 114.867V113.189H202.271V114.867H201.77Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.77 117.923V116.246H202.271V117.923H201.77Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.77 120.98V119.302H202.271V120.98H201.77Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.77 124.036V122.358H202.271V124.036H201.77Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.77 127.092V125.415H202.271V127.092H201.77Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.77 130.149V128.471H202.271V130.149H201.77Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.77 133.209V131.531H202.271V133.209H201.77Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.77 139.322V137.644H202.271V139.322H201.77Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.77 142.378V140.7H202.271V142.378H201.77Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.77 145.434V143.757H202.271V145.434H201.77Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.77 148.491V146.813H202.271V148.491H201.77Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.77 151.547V149.869H202.271V151.547H201.77Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.77 154.607V152.93H202.271V154.607H201.77Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.77 157.664V155.986H202.271V157.664H201.77Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.77 160.72V159.042H202.271V160.72H201.77Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.77 136.265V134.588H202.271V136.265H201.77Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.032 111.791V110.133H171.451V111.791H171.032Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 111.791V110.133H172.772V111.791H172.352Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82 111.791V110.133H174.24V111.791H173.82Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.141 111.791V110.133H175.56V111.791H175.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.032 114.51V112.852H171.451V114.51H171.032Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 114.51V112.852H172.772V114.51H172.352Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82 114.51V112.852H174.24V114.51H173.82Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.141 114.51V112.852H175.56V114.51H175.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.032 117.846V116.187H171.451V117.846H171.032Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 117.846V116.187H172.772V117.846H172.352Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82 117.846V116.187H174.24V117.846H173.82Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.141 117.846V116.187H175.56V117.846H175.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.032 120.564V118.906H171.451V120.564H171.032Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 120.564V118.906H172.772V120.564H172.352Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82 120.564V118.906H174.24V120.564H173.82Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.141 120.564V118.906H175.56V120.564H175.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.032 123.904V122.246H171.451V123.904H171.032Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 123.904V122.246H172.772V123.904H172.352Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82 123.904V122.246H174.24V123.904H173.82Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.141 123.904V122.246H175.56V123.904H175.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.032 126.622V124.964H171.451V126.622H171.032Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 126.622V124.964H172.772V126.622H172.352Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82 126.622V124.964H174.24V126.622H173.82Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.141 126.622V124.964H175.56V126.622H175.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.032 129.959V128.3H171.451V129.959H171.032Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 129.959V128.3H172.772V129.959H172.352Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82 129.959V128.3H174.24V129.959H173.82Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.141 129.959V128.3H175.56V129.959H175.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.032 132.677V131.019H171.451V132.677H171.032Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 132.677V131.019H172.772V132.677H172.352Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82 132.677V131.019H174.24V132.677H173.82Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.141 132.677V131.019H175.56V132.677H175.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.032 136.017V134.359H171.451V136.017H171.032Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 136.017V134.359H172.772V136.017H172.352Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82 136.017V134.359H174.24V136.017H173.82Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.141 136.017V134.359H175.56V136.017H175.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.032 138.735V137.077H171.451V138.735H171.032Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 138.735V137.077H172.772V138.735H172.352Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82 138.735V137.077H174.24V138.735H173.82Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.141 138.735V137.077H175.56V138.735H175.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.032 142.071V140.413H171.451V142.071H171.032Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 142.071V140.413H172.772V142.071H172.352Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82 142.071V140.413H174.24V142.071H173.82Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.141 142.071V140.413H175.56V142.071H175.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.032 144.79V143.131H171.451V144.79H171.032Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 144.79V143.131H172.772V144.79H172.352Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82 144.79V143.131H174.24V144.79H173.82Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.141 144.79V143.131H175.56V144.79H175.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.032 148.13V146.471H171.451V148.13H171.032Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 148.13V146.471H172.772V148.13H172.352Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82 148.13V146.471H174.24V148.13H173.82Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.141 148.13V146.471H175.56V148.13H175.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.032 150.848V149.19H171.451V150.848H171.032Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 150.848V149.19H172.772V150.848H172.352Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82 150.848V149.19H174.24V150.848H173.82Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.141 150.848V149.19H175.56V150.848H175.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.032 154.184V152.526H171.451V154.184H171.032Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 154.184V152.526H172.772V154.184H172.352Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82 154.184V152.526H174.24V154.184H173.82Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.141 154.184V152.526H175.56V154.184H175.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.032 156.906V155.248H171.451V156.906H171.032Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 156.906V155.248H172.772V156.906H172.352Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82 156.906V155.248H174.24V156.906H173.82Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.141 156.906V155.248H175.56V156.906H175.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.032 160.242V158.584H171.451V160.242H171.032Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 160.242V158.584H172.772V160.242H172.352Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82 160.242V158.584H174.24V160.242H173.82Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.141 160.242V158.584H175.56V160.242H175.141Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.238 111.791V110.133H177.657V111.791H177.238Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.554 111.791V110.133H178.974V111.791H178.554Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.022 111.791V110.133H180.442V111.791H180.022Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.343 111.791V110.133H181.762V111.791H181.343Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.238 114.51V112.852H177.657V114.51H177.238Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.554 114.51V112.852H178.974V114.51H178.554Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.022 114.51V112.852H180.442V114.51H180.022Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.343 114.51V112.852H181.762V114.51H181.343Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.238 117.846V116.187H177.657V117.846H177.238Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.554 117.846V116.187H178.974V117.846H178.554Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.022 117.846V116.187H180.442V117.846H180.022Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.343 117.846V116.187H181.762V117.846H181.343Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.238 120.564V118.906H177.657V120.564H177.238Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.554 120.564V118.906H178.974V120.564H178.554Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.022 120.564V118.906H180.442V120.564H180.022Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.343 120.564V118.906H181.762V120.564H181.343Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.238 123.904V122.246H177.657V123.904H177.238Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.554 123.904V122.246H178.974V123.904H178.554Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.022 123.904V122.246H180.442V123.904H180.022Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.343 123.904V122.246H181.762V123.904H181.343Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.238 126.622V124.964H177.657V126.622H177.238Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.554 126.622V124.964H178.974V126.622H178.554Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.022 126.622V124.964H180.442V126.622H180.022Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.343 126.622V124.964H181.762V126.622H181.343Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.238 129.959V128.3H177.657V129.959H177.238Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.554 129.959V128.3H178.974V129.959H178.554Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.022 129.959V128.3H180.442V129.959H180.022Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.343 129.959V128.3H181.762V129.959H181.343Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.238 132.677V131.019H177.657V132.677H177.238Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.554 132.677V131.019H178.974V132.677H178.554Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.022 132.677V131.019H180.442V132.677H180.022Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.343 132.677V131.019H181.762V132.677H181.343Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.238 136.017V134.359H177.657V136.017H177.238Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.554 136.017V134.359H178.974V136.017H178.554Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.022 136.017V134.359H180.442V136.017H180.022Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.343 136.017V134.359H181.762V136.017H181.343Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.238 138.735V137.077H177.657V138.735H177.238Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.554 138.735V137.077H178.974V138.735H178.554Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.022 138.735V137.077H180.442V138.735H180.022Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.343 138.735V137.077H181.762V138.735H181.343Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.238 142.071V140.413H177.657V142.071H177.238Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.554 142.071V140.413H178.974V142.071H178.554Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.022 142.071V140.413H180.442V142.071H180.022Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.343 142.071V140.413H181.762V142.071H181.343Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.238 144.79V143.131H177.657V144.79H177.238Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.554 144.79V143.131H178.974V144.79H178.554Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.022 144.79V143.131H180.442V144.79H180.022Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.343 144.79V143.131H181.762V144.79H181.343Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.238 148.13V146.471H177.657V148.13H177.238Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.554 148.13V146.471H178.974V148.13H178.554Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.022 148.13V146.471H180.442V148.13H180.022Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.343 148.13V146.471H181.762V148.13H181.343Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.238 150.848V149.19H177.657V150.848H177.238Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.554 150.848V149.19H178.974V150.848H178.554Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.022 150.848V149.19H180.442V150.848H180.022Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.343 150.848V149.19H181.762V150.848H181.343Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.238 154.184V152.526H177.657V154.184H177.238Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.554 154.184V152.526H178.974V154.184H178.554Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.022 154.184V152.526H180.442V154.184H180.022Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.343 154.184V152.526H181.762V154.184H181.343Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.238 156.906V155.248H177.657V156.906H177.238Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.554 156.906V155.248H178.974V156.906H178.554Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.022 156.906V155.248H180.442V156.906H180.022Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.343 156.906V155.248H181.762V156.906H181.343Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.238 160.242V158.584H177.657V160.242H177.238Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.554 160.242V158.584H178.974V160.242H178.554Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.022 160.242V158.584H180.442V160.242H180.022Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.343 160.242V158.584H181.762V160.242H181.343Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44 111.791V110.133H183.859V111.791H183.44Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.76 111.791V110.133H185.18V111.791H184.76Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.224 111.791V110.133H186.644V111.791H186.224Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.545 111.791V110.133H187.964V111.791H187.545Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44 114.51V112.852H183.859V114.51H183.44Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.76 114.51V112.852H185.18V114.51H184.76Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.224 114.51V112.852H186.644V114.51H186.224Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.545 114.51V112.852H187.964V114.51H187.545Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44 117.846V116.187H183.859V117.846H183.44Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.76 117.846V116.187H185.18V117.846H184.76Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.224 117.846V116.187H186.644V117.846H186.224Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.545 117.846V116.187H187.964V117.846H187.545Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44 120.564V118.906H183.859V120.564H183.44Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.76 120.564V118.906H185.18V120.564H184.76Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.224 120.564V118.906H186.644V120.564H186.224Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.545 120.564V118.906H187.964V120.564H187.545Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44 123.904V122.246H183.859V123.904H183.44Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.76 123.904V122.246H185.18V123.904H184.76Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.224 123.904V122.246H186.644V123.904H186.224Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.545 123.904V122.246H187.964V123.904H187.545Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44 126.622V124.964H183.859V126.622H183.44Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.76 126.622V124.964H185.18V126.622H184.76Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.224 126.622V124.964H186.644V126.622H186.224Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.545 126.622V124.964H187.964V126.622H187.545Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44 129.959V128.3H183.859V129.959H183.44Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.76 129.959V128.3H185.18V129.959H184.76Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.224 129.959V128.3H186.644V129.959H186.224Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.545 129.959V128.3H187.964V129.959H187.545Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44 132.677V131.019H183.859V132.677H183.44Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.76 132.677V131.019H185.18V132.677H184.76Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.224 132.677V131.019H186.644V132.677H186.224Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.545 132.677V131.019H187.964V132.677H187.545Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44 136.017V134.359H183.859V136.017H183.44Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.76 136.017V134.359H185.18V136.017H184.76Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.224 136.017V134.359H186.644V136.017H186.224Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.545 136.017V134.359H187.964V136.017H187.545Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44 138.735V137.077H183.859V138.735H183.44Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.76 138.735V137.077H185.18V138.735H184.76Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.224 138.735V137.077H186.644V138.735H186.224Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.545 138.735V137.077H187.964V138.735H187.545Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44 142.071V140.413H183.859V142.071H183.44Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.76 142.071V140.413H185.18V142.071H184.76Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.224 142.071V140.413H186.644V142.071H186.224Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.545 142.071V140.413H187.964V142.071H187.545Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44 144.79V143.131H183.859V144.79H183.44Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.76 144.79V143.131H185.18V144.79H184.76Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.224 144.79V143.131H186.644V144.79H186.224Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.545 144.79V143.131H187.964V144.79H187.545Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44 148.13V146.471H183.859V148.13H183.44Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.76 148.13V146.471H185.18V148.13H184.76Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.224 148.13V146.471H186.644V148.13H186.224Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.545 148.13V146.471H187.964V148.13H187.545Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44 150.848V149.19H183.859V150.848H183.44Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.76 150.848V149.19H185.18V150.848H184.76Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.224 150.848V149.19H186.644V150.848H186.224Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.545 150.848V149.19H187.964V150.848H187.545Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44 154.184V152.526H183.859V154.184H183.44Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.76 154.184V152.526H185.18V154.184H184.76Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.224 154.184V152.526H186.644V154.184H186.224Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.545 154.184V152.526H187.964V154.184H187.545Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44 156.906V155.248H183.859V156.906H183.44Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.76 156.906V155.248H185.18V156.906H184.76Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.224 156.906V155.248H186.644V156.906H186.224Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.545 156.906V155.248H187.964V156.906H187.545Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44 160.242V158.584H183.859V160.242H183.44Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.76 160.242V158.584H185.18V160.242H184.76Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.224 160.242V158.584H186.644V160.242H186.224Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.545 160.242V158.584H187.964V160.242H187.545Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.776 111.791V110.133H169.277V111.791H168.776Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.776 114.817V113.158H169.277V114.817H168.776Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.776 117.846V116.187H169.277V117.846H168.776Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.776 120.875V119.217H169.277V120.875H168.776Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.776 123.904V122.246H169.277V123.904H168.776Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.776 126.929V125.271H169.277V126.929H168.776Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.776 129.959V128.3H169.277V129.959H168.776Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.776 132.988V131.329H169.277V132.988H168.776Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.776 139.046V137.388H169.277V139.046H168.776Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.776 142.071V140.413H169.277V142.071H168.776Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.776 145.1V143.442H169.277V145.1H168.776Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.776 148.13V146.471H169.277V148.13H168.776Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.776 151.159V149.5H169.277V151.159H168.776Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.776 154.184V152.526H169.277V154.184H168.776Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.776 157.213V155.555H169.277V157.213H168.776Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.776 160.242V158.584H169.277V160.242H168.776Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.776 136.017V134.359H169.277V136.017H168.776Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.723 111.791V110.133H190.224V111.791H189.723Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.723 114.817V113.158H190.224V114.817H189.723Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.723 117.846V116.187H190.224V117.846H189.723Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.723 120.875V119.217H190.224V120.875H189.723Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.723 123.904V122.246H190.224V123.904H189.723Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.723 126.929V125.271H190.224V126.929H189.723Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.723 129.959V128.3H190.224V129.959H189.723Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.723 132.988V131.329H190.224V132.988H189.723Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.723 139.046V137.388H190.224V139.046H189.723Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.723 142.071V140.413H190.224V142.071H189.723Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.723 145.1V143.442H190.224V145.1H189.723Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.723 148.13V146.471H190.224V148.13H189.723Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.723 151.159V149.5H190.224V151.159H189.723Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.723 154.184V152.526H190.224V154.184H189.723Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.723 157.213V155.555H190.224V157.213H189.723Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.723 160.242V158.584H190.224V160.242H189.723Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.723 136.017V134.359H190.224V136.017H189.723Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.181 105.578V104.607H190.819V105.578H168.181Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.471 104.898V103.182H167.199V104.898H159.471Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.801 104.898V103.182H199.529V104.898H191.801Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.432 106.758L155.076 105.174H158.488V106.758H155.432Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.512 106.758V105.174H203.924L203.568 106.758H200.512Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.471 163.901V161.473H199.529V163.901H159.471Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.199 163.202V162.172H184.228V163.202H183.199Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.467 163.202V162.172H192.496V163.202H191.467Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.888 163.202V162.172H175.917V163.202H174.888Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.578 163.202V162.172H167.607V163.202H166.578Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.677 103.846V85.3096H185.234V103.846H173.677Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.096 101.985V100.327H174.597V101.985H174.096Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.096 97.6281V95.9698H174.597V97.6281H174.096Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.096 93.2746V91.6164H174.597V93.2746H174.096Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.096 88.9212V87.2629H174.597V88.9212H174.096Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.671 101.985V100.327H177.172V101.985H176.671Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.671 97.6281V95.9698H177.172V97.6281H176.671Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.671 93.2746V91.6164H177.172V93.2746H176.671Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.671 88.9212V87.2629H177.172V88.9212H176.671Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.246 101.985V100.327H179.747V101.985H179.246Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.246 97.6281V95.9698H179.747V97.6281H179.246Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.246 93.2746V91.6164H179.747V93.2746H179.246Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.246 88.9212V87.2629H179.747V88.9212H179.246Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.82 101.985V100.327H182.321V101.985H181.82Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.82 97.6281V95.9698H182.321V97.6281H181.82Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.82 93.2746V91.6164H182.321V93.2746H181.82Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.82 88.9212V87.2629H182.321V88.9212H181.82Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.403 101.985V100.327H184.904V101.985H184.403Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.403 97.6281V95.9698H184.904V97.6281H184.403Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.403 93.2746V91.6164H184.904V93.2746H184.403Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.403 88.9212V87.2629H184.904V88.9212H184.403Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.181 103.846V84.9095H172.527V103.846H168.181Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.286 88.4629V86.8978H170.426V88.4629H170.286Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.286 92.2533V90.6882H170.426V92.2533H170.286Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.286 96.2495V94.6844H170.426V96.2495H170.286Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.286 100.044V98.4786H170.426V100.044H170.286Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.341 103.985V85.0493H190.687V103.985H186.341Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.492 88.4629V86.8978H188.632V88.4629H188.492Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.492 92.2533V90.6882H188.632V92.2533H188.492Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.492 96.2495V94.6844H188.632V96.2495H188.492Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.492 100.044V98.4786H188.632V100.044H188.492Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.409 82.89V80.6725H174.057V82.89H173.409Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.722 79.8143V83.558H186.376V79.8143H190.722Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.498 80.6686V82.8861H184.85V80.6686H185.498Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.974 79.8103H177.009C177.038 80.4338 177.305 81.0226 177.756 81.4549C178.21 81.8898 178.813 82.1326 179.442 82.1326C180.07 82.1326 180.674 81.8898 181.127 81.4549C181.578 81.0226 181.845 80.4338 181.874 79.8103H183.999V83.554H174.974V79.8103Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.376 78.4589V75.7172H192.018L190.794 78.4589H186.376Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.108 68.9519V61.9848H183.11V68.9519H176.108Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.108 61.1111V59.1499H183.11V61.1111H176.108Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.034 70.0901V63.1397L175.719 62.0505V69.001L172.034 70.0901Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.034 62.2348V60.2898L175.719 59.2147V61.1597L172.034 62.2348Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.187 62.2423L183.502 61.1637V59.2147L187.187 60.2898V62.2423Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.187 70.0901L183.502 69.001V62.0505L187.187 63.1397V70.0901Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.463 57.3169V53.2625H181.537V57.3169H177.463Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.463 52.579V51.5499H181.537V52.579H177.463Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.001 57.9737V53.9397L177.075 53.328V57.362L175.001 57.9737Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.001 53.2327V52.2198L177.075 51.6147V52.6276L175.001 53.2327Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.999 53.2366L181.925 52.6315V51.6147L183.999 52.2198V53.2366Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.999 57.9737L181.925 57.362V53.328L183.999 53.9397V57.9737Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.214 74.8549H170.236V73.3182L175.611 71.5652V78.4589H173.409V75.0491V74.8549H173.214Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.786 74.8549H185.592L185.591 75.0489L185.588 78.4589H183.389V71.5651L188.768 73.3182V74.8549H185.786Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.181 83.558V79.8143H172.527V83.558H168.181Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.113 78.4589L166.889 75.7172H172.527V78.4589H168.113Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.011 78.4589V71.4918H183.001L183.009 78.4589H181.451C181.247 78.1445 180.97 77.8827 180.644 77.6956C180.285 77.4897 179.879 77.3813 179.465 77.3813C179.051 77.3813 178.645 77.4897 178.286 77.6956C177.96 77.8827 177.683 78.1445 177.479 78.4589H176.011Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.459 78.3618L179.499 78.3619L179.523 78.3514C179.866 78.3668 180.193 78.5035 180.445 78.7377C180.704 78.9791 180.866 79.3074 180.9 79.6601V79.6601V79.6604V79.6606V79.6609V79.6611V79.6614V79.6616V79.6619V79.6621V79.6624V79.6626V79.6629V79.6631V79.6634V79.6636V79.6639V79.6641V79.6644V79.6646V79.6649V79.6651V79.6654V79.6656V79.6659V79.6661V79.6664V79.6666V79.6669V79.6671V79.6674V79.6676V79.6679V79.6681V79.6684V79.6686V79.6689V79.6691V79.6694V79.6696V79.6699V79.6701V79.6704V79.6706V79.6709V79.6711V79.6714V79.6716V79.6719V79.6721V79.6724V79.6726V79.6729V79.6731V79.6734V79.6736V79.6739V79.6741V79.6744V79.6746V79.6749V79.6751V79.6754V79.6756V79.6759V79.6761V79.6764V79.6766V79.6769V79.6771V79.6774V79.6776V79.6779V79.6781V79.6784V79.6786V79.6789V79.6791V79.6794V79.6796V79.6799V79.6801V79.6804V79.6806V79.6809V79.6811V79.6814V79.6816V79.6819V79.6821V79.6824V79.6826V79.6829V79.6831V79.6834V79.6836V79.6839V79.6841V79.6844V79.6846V79.6849V79.6851V79.6854V79.6856V79.6859V79.6861V79.6864V79.6866V79.6869V79.6871V79.6874V79.6876V79.6879V79.6881V79.6884V79.6886V79.6889V79.6892V79.6894V79.6897V79.6899V79.6902V79.6904V79.6907V79.6909V79.6912V79.6914V79.6917V79.6919V79.6922V79.6924V79.6927V79.6929V79.6932V79.6934V79.6937V79.6939V79.6942V79.6944V79.6947V79.6949V79.6952V79.6954V79.6957V79.6959V79.6962V79.6964V79.6967V79.6969V79.6972V79.6974V79.6977V79.6979V79.6982V79.6984V79.6987V79.6989V79.6992V79.6994V79.6997V79.6999V79.7002V79.7004V79.7007V79.7009V79.7012V79.7014V79.7017V79.7019V79.7022V79.7024V79.7027V79.7029V79.7032V79.7034V79.7037V79.7039V79.7042V79.7044V79.7047V79.7049V79.7052V79.7054V79.7057V79.7059V79.7062V79.7064V79.7067V79.7069V79.7072V79.7074V79.7077V79.7079V79.7082V79.7084V79.7087V79.7089V79.7092V79.7094V79.7097V79.7099V79.7102V79.7104V79.7107V79.7109V79.7112V79.7114V79.7117V79.7119V79.7122V79.7124V79.7127V79.7129V79.7132V79.7134V79.7137V79.7139V79.7142V79.7144V79.7147V79.7149V79.7152V79.7154V79.7157V79.7159V79.7162V79.7164V79.7167V79.7169V79.7172V79.7174V79.7177V79.7179V79.7182V79.7184V79.7187V79.7189V79.7192V79.7194V79.7197V79.7199V79.7202V79.7204V79.7207V79.7209V79.7212V79.7214V79.7217V79.7219V79.7222V79.7224V79.7227V79.7229V79.7232V79.7234V79.7237V79.7239V79.7242V79.7244V79.7247V79.7249V79.7252V79.7254V79.7257V79.7259V79.7262V79.7264V79.7267V79.7269V79.7272V79.7274V79.7277V79.7279V79.7282V79.7284V79.7287V79.7289V79.7292V79.7294V79.7297V79.73V79.7302V79.7305V79.7307V79.731V79.7312V79.7315V79.7317V79.732V79.7322V79.7325V79.7327V79.733V79.7332V79.7335V79.7337V79.734V79.7342V79.7345V79.7347V79.735V79.7352V79.7355V79.7357V79.736V79.7362V79.7365V79.7367V79.737V79.7372V79.7375V79.7377V79.738V79.7382V79.7385V79.7387V79.739V79.7392V79.7395V79.7397V79.74V79.7402V79.7405V79.7407V79.741V79.7412V79.7415V79.7417V79.742V79.7422V79.7425V79.7427V79.743V79.7432V79.7435V79.7437V79.744V79.7442V79.7445V79.7447V79.745V79.7452V79.7455V79.7457V79.746V79.7462V79.7465V79.7467V79.747V79.7472V79.7475V79.7477V79.748V79.7482V79.7485V79.7487V79.749V79.7492V79.7495V79.7497V79.75V79.7502V79.7505V79.7507V79.751V79.7512V79.7515V79.7517V79.752V79.7522V79.7525V79.7527V79.753V79.7532V79.7535V79.7537V79.754V79.7542V79.7545V79.7547V79.755V79.7552V79.7555V79.7557V79.756V79.7562V79.7565V79.7567V79.757V79.7572V79.7575V79.7577V79.758V79.7582V79.7585V79.7587V79.759V79.7592V79.7595V79.7597V79.76V79.7602V79.7605V79.7607V79.761V79.7612V79.7615V79.7617V79.762V79.7622V79.7625V79.7627V79.763V79.7632V79.7635V79.7637V79.764V79.7642V79.7645V79.7647V79.765V79.7652V79.7655V79.7657V79.766V79.7662V79.7665V79.7667V79.767V79.7672V79.7675V79.7677V79.768V79.7682V79.7685V79.7687V79.769V79.7692V79.7695V79.7697V79.77V79.7702V79.7705V79.7708V79.771V79.7713V79.7715V79.7718V79.772V79.7723V79.7725V79.7728V79.773V79.7733V79.7735V79.7738V79.774V79.7743V79.7745V79.7748V79.775V79.7753V79.7755V79.7758V79.776V79.7763V79.7765V79.7768V79.777V79.7773V79.7775V79.7778V79.778V79.7783V79.7785V79.7788V79.779V79.7793C180.9 80.1583 180.749 80.5218 180.481 80.7898C180.213 81.0578 179.85 81.2084 179.471 81.2084C179.092 81.2084 178.728 81.0578 178.46 80.7898C178.192 80.5218 178.042 80.1583 178.042 79.7793V79.779V79.7788V79.7785V79.7783V79.778V79.7778V79.7775V79.7773V79.777V79.7768V79.7765V79.7763V79.776V79.7758V79.7755V79.7753V79.775V79.7748V79.7745V79.7743V79.774V79.7738V79.7735V79.7733V79.773V79.7728V79.7725V79.7723V79.772V79.7718V79.7715V79.7713V79.771V79.7708V79.7705V79.7702V79.77V79.7697V79.7695V79.7692V79.769V79.7687V79.7685V79.7682V79.768V79.7677V79.7675V79.7672V79.767V79.7667V79.7665V79.7662V79.766V79.7657V79.7655V79.7652V79.765V79.7647V79.7645V79.7642V79.764V79.7637V79.7635V79.7632V79.763V79.7627V79.7625V79.7622V79.762V79.7617V79.7615V79.7612V79.761V79.7607V79.7605V79.7602V79.76V79.7597V79.7595V79.7592V79.759V79.7587V79.7585V79.7582V79.758V79.7577V79.7575V79.7572V79.757V79.7567V79.7565V79.7562V79.756V79.7557V79.7555V79.7552V79.755V79.7547V79.7545V79.7542V79.754V79.7537V79.7535V79.7532V79.753V79.7527V79.7525V79.7522V79.752V79.7517V79.7515V79.7512V79.751V79.7507V79.7505V79.7502V79.75V79.7497V79.7495V79.7492V79.749V79.7487V79.7485V79.7482V79.748V79.7477V79.7475V79.7472V79.747V79.7467V79.7465V79.7462V79.746V79.7457V79.7455V79.7452V79.745V79.7447V79.7445V79.7442V79.744V79.7437V79.7435V79.7432V79.743V79.7427V79.7425V79.7422V79.742V79.7417V79.7415V79.7412V79.741V79.7407V79.7405V79.7402V79.74V79.7397V79.7395V79.7392V79.739V79.7387V79.7385V79.7382V79.738V79.7377V79.7375V79.7372V79.737V79.7367V79.7365V79.7362V79.736V79.7357V79.7355V79.7352V79.735V79.7347V79.7345V79.7342V79.734V79.7337V79.7335V79.7332V79.733V79.7327V79.7325V79.7322V79.732V79.7317V79.7315V79.7312V79.731V79.7307V79.7305V79.7302V79.73V79.7297V79.7294V79.7292V79.7289V79.7287V79.7284V79.7282V79.7279V79.7277V79.7274V79.7272V79.7269V79.7267V79.7264V79.7262V79.7259V79.7257V79.7254V79.7252V79.7249V79.7247V79.7244V79.7242V79.7239V79.7237V79.7234V79.7232V79.7229V79.7227V79.7224V79.7222V79.7219V79.7217V79.7214V79.7212V79.7209V79.7207V79.7204V79.7202V79.7199V79.7197V79.7194V79.7192V79.7189V79.7187V79.7184V79.7182V79.7179V79.7177V79.7174V79.7172V79.7169V79.7167V79.7164V79.7162V79.7159V79.7157V79.7154V79.7152V79.7149V79.7147V79.7144V79.7142V79.7139V79.7137V79.7134V79.7132V79.7129V79.7127V79.7124V79.7122V79.7119V79.7117V79.7114V79.7112V79.7109V79.7107V79.7104V79.7102V79.7099V79.7097V79.7094V79.7092V79.7089V79.7087V79.7084V79.7082V79.7079V79.7077V79.7074V79.7072V79.7069V79.7067V79.7064V79.7062V79.7059V79.7057V79.7054V79.7052V79.7049V79.7047V79.7044V79.7042V79.7039V79.7037V79.7034V79.7032V79.7029V79.7027V79.7024V79.7022V79.7019V79.7017V79.7014V79.7012V79.7009V79.7007V79.7004V79.7002V79.6999V79.6997V79.6994V79.6992V79.6989V79.6987V79.6984V79.6982V79.6979V79.6977V79.6974V79.6972V79.6969V79.6967V79.6964V79.6962V79.6959V79.6957V79.6954V79.6952V79.6949V79.6947V79.6944V79.6942V79.6939V79.6937V79.6934V79.6932V79.6929V79.6927V79.6924V79.6922V79.6919V79.6917V79.6914V79.6912V79.6909V79.6907V79.6904V79.6902V79.6899V79.6897V79.6894V79.6892V79.6889V79.6886V79.6884V79.6881V79.6879V79.6876V79.6874V79.6871V79.6869V79.6866V79.6864V79.6861V79.6859V79.6856V79.6854V79.6851V79.6849V79.6846V79.6844V79.6841V79.6839V79.6836V79.6834V79.6831V79.6829V79.6826V79.6824V79.6821V79.6819V79.6816V79.6814V79.6811V79.6809V79.6806V79.6804V79.6801V79.6799V79.6796V79.6794V79.6791V79.6789V79.6786V79.6784V79.6781V79.6779V79.6776V79.6774V79.6771V79.6769V79.6766V79.6764V79.6761V79.6759V79.6756V79.6754V79.6751V79.6749V79.6746V79.6744V79.6741V79.6739V79.6736V79.6734V79.6731V79.6729V79.6726V79.6724V79.6721V79.6719V79.6716V79.6714V79.6711V79.6709V79.6706V79.6704V79.6701V79.6699V79.6696V79.6694V79.6691V79.6689V79.6686V79.6684V79.6681V79.6679V79.6676V79.6674V79.6671V79.6669V79.6666V79.6664V79.6661V79.6659V79.6656V79.6654V79.6651V79.6649V79.6646V79.6644V79.6641V79.6639V79.6636V79.6634V79.6631V79.6629V79.6626V79.6624V79.6621V79.6619V79.6616V79.6614V79.6611V79.6609V79.6606V79.6604V79.6601V79.6599V79.6596V79.6594V79.6593C178.061 79.442 178.131 79.2321 178.246 79.0466L178.246 79.0466L178.247 79.0444C178.373 78.8356 178.55 78.6629 178.763 78.5433C178.975 78.4236 179.215 78.3611 179.459 78.3618Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.307 48.0081H177.736C177.76 46.8494 177.291 45.8795 176.531 45.0372H182.511C181.748 45.8797 181.283 46.8497 181.307 48.0081Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.731 50.3926V49.0295H181.25V50.3926H177.731Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.43 42.2993H178.598C178.586 41.9845 178.516 41.674 178.39 41.384C178.301 41.1782 178.184 40.9859 178.045 40.8119H180.988C180.848 40.9853 180.731 41.177 180.641 41.3823C180.514 41.6726 180.442 41.9837 180.43 42.2993Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.609 43.6352V43.0449H180.403V43.6352H178.609Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.554 24.8484L180.388 39.7594H178.62L179.451 24.8331L179.554 24.8484Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.112 23.3518C177.314 23.7324 177.604 24.0608 177.961 24.3079C178.413 24.621 178.95 24.7887 179.5 24.7887C180.05 24.7887 180.587 24.621 181.039 24.3079C181.396 24.0608 181.686 23.7324 181.888 23.3518C181.708 23.8079 181.401 24.204 181.002 24.4919C180.565 24.8074 180.039 24.9772 179.5 24.9772C178.961 24.9772 178.435 24.8074 177.998 24.4919C177.599 24.204 177.292 23.8079 177.112 23.3518Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.502 20.6275L179.795 21.5281L179.839 21.6622H179.98H180.923L180.161 22.2157L180.047 22.2984L180.09 22.4325L180.38 23.3321L179.616 22.7752L179.502 22.6918L179.388 22.7752L178.626 23.3307L178.918 22.4329L178.961 22.2984L178.847 22.2155L178.082 21.6622H179.024H179.165L179.209 21.5281L179.502 20.6275Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.366 64.5132V63.1889H179.727V64.5132H179.366Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.366 55.9499V54.6256H179.727V55.9499H179.366Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.366 67.5889V66.2646H179.727V67.5889H179.366Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.525 64.0031V65.3196L185.164 65.2335V63.9188L185.525 64.0031Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.149 55.0209V56.3232L183.024 56.2809V54.9785L183.149 55.0209Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.1 54.9785V56.2809L175.976 56.3232V55.0209L176.1 54.9785Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.525 67.0827V68.3966L185.164 68.3124V66.9985L185.525 67.0827Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.193 65.2333L173.828 65.3199V64.0032L174.193 63.9186V65.2333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.193 68.3122L173.828 68.3969V67.0829L174.193 66.9982V68.3122Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.441 181.819H111.334V136.79H115.784L118.441 139.02V181.819Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.63 181.819V139.124H154.492V181.819H149.63Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.563 147.9V147.306H119.769V147.9H119.563Z",
    fill: "#FFEF0C",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.333 141.531V140.009H150.566V141.531H150.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.346 141.531V140.009H151.579V141.531H151.346Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.469 141.531V140.009H152.702V141.531H152.469Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.482 141.531V140.009H153.715V141.531H153.482Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.333 144.071V142.549H150.566V144.071H150.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.346 144.071V142.549H151.579V144.071H151.346Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.469 144.071V142.549H152.702V144.071H152.469Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.482 144.071V142.549H153.715V144.071H153.482Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.333 147.186V145.664H150.566V147.186H150.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.346 147.186V145.664H151.579V147.186H151.346Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.469 147.186V145.664H152.702V147.186H152.469Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.482 147.186V145.664H153.715V147.186H153.482Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.333 149.726V148.203H150.566V149.726H150.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.346 149.726V148.203H151.579V149.726H151.346Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.469 149.726V148.203H152.702V149.726H152.469Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.482 149.726V148.203H153.715V149.726H153.482Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.333 152.844V151.322H150.566V152.844H150.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.346 152.844V151.322H151.579V152.844H151.346Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.469 152.844V151.322H152.702V152.844H152.469Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.482 152.844V151.322H153.715V152.844H153.482Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.333 155.384V153.862H150.566V155.384H150.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.346 155.384V153.862H151.579V155.384H151.346Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.469 155.384V153.862H152.702V155.384H152.469Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.482 155.384V153.862H153.715V155.384H153.482Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.333 158.499V156.976H150.566V158.499H150.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.346 158.499V156.976H151.579V158.499H151.346Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.469 158.499V156.976H152.702V158.499H152.469Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.482 158.499V156.976H153.715V158.499H153.482Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.333 161.038V159.516H150.566V161.038H150.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.346 161.038V159.516H151.579V161.038H151.346Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.469 161.038V159.516H152.702V161.038H152.469Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.482 161.038V159.516H153.715V161.038H153.482Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.333 164.157V162.635H150.566V164.157H150.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.346 164.157V162.635H151.579V164.157H151.346Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.469 164.157V162.635H152.702V164.157H152.469Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.482 164.157V162.635H153.715V164.157H153.482Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.333 166.693V165.171H150.566V166.693H150.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.346 166.693V165.171H151.579V166.693H151.346Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.469 166.693V165.171H152.702V166.693H152.469Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.482 166.693V165.171H153.715V166.693H153.482Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.333 169.811V168.289H150.566V169.811H150.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.346 169.811V168.289H151.579V169.811H151.346Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.469 169.811V168.289H152.702V169.811H152.469Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.482 169.811V168.289H153.715V169.811H153.482Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.333 172.351V170.829H150.566V172.351H150.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.346 172.351V170.829H151.579V172.351H151.346Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.469 172.351V170.829H152.702V172.351H152.469Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.482 172.351V170.829H153.715V172.351H153.482Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.333 175.47V173.947H150.566V175.47H150.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.346 175.47V173.947H151.579V175.47H151.346Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.469 175.47V173.947H152.702V175.47H152.469Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.482 175.47V173.947H153.715V175.47H153.482Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.333 178.006V176.483H150.566V178.006H150.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.346 178.006V176.483H151.579V178.006H151.346Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.469 178.006V176.483H152.702V178.006H152.469Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.482 178.006V176.483H153.715V178.006H153.482Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.563 181.819V139.124H148.647V181.819H119.563Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.232 141.217V139.694H142.465V141.217H142.232Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.245 141.217V139.694H143.478V141.217H143.245Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.232 143.757V142.234H142.465V143.757H142.232Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.245 143.757V142.234H143.478V143.757H143.245Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.232 146.871V145.349H142.465V146.871H142.232Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.245 146.871V145.349H143.478V146.871H143.245Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.232 149.411V147.889H142.465V149.411H142.232Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.245 149.411V147.889H143.478V149.411H143.245Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.232 152.53V151.007H142.465V152.53H142.232Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.245 152.53V151.007H143.478V152.53H143.245Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.232 155.069V153.547H142.465V155.069H142.232Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.245 155.069V153.547H143.478V155.069H143.245Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.232 158.184V156.662H142.465V158.184H142.232Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.245 158.184V156.662H143.478V158.184H143.245Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.232 160.724V159.202H142.465V160.724H142.232Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.245 160.724V159.202H143.478V160.724H143.245Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.232 163.842V162.32H142.465V163.842H142.232Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.245 163.842V162.32H143.478V163.842H143.245Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.232 166.382V164.86H142.465V166.382H142.232Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.245 166.382V164.86H143.478V166.382H143.245Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.232 169.497V167.975H142.465V169.497H142.232Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.245 169.497V167.975H143.478V169.497H143.245Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.232 172.037V170.514H142.465V172.037H142.232Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.245 172.037V170.514H143.478V172.037H143.245Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.232 175.155V173.633H142.465V175.155H142.232Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.245 175.155V173.633H143.478V175.155H143.245Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.232 177.695V176.173H142.465V177.695H142.232Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.245 177.695V176.173H143.478V177.695H143.245Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.263 141.217V139.694H138.496V141.217H138.263Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.272 141.217V139.694H139.505V141.217H139.272Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.263 143.757V142.234H138.496V143.757H138.263Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.272 143.757V142.234H139.505V143.757H139.272Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.263 146.871V145.349H138.496V146.871H138.263Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.272 146.871V145.349H139.505V146.871H139.272Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.263 149.411V147.889H138.496V149.411H138.263Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.272 149.411V147.889H139.505V149.411H139.272Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.263 152.53V151.007H138.496V152.53H138.263Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.272 152.53V151.007H139.505V152.53H139.272Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.263 155.069V153.547H138.496V155.069H138.263Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.272 155.069V153.547H139.505V155.069H139.272Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.263 158.184V156.662H138.496V158.184H138.263Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.272 158.184V156.662H139.505V158.184H139.272Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.263 160.724V159.202H138.496V160.724H138.263Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.272 160.724V159.202H139.505V160.724H139.272Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.263 163.842V162.32H138.496V163.842H138.263Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.272 163.842V162.32H139.505V163.842H139.272Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.263 166.382V164.86H138.496V166.382H138.263Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.272 166.382V164.86H139.505V166.382H139.272Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.263 169.497V167.975H138.496V169.497H138.263Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.272 169.497V167.975H139.505V169.497H139.272Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.263 172.037V170.514H138.496V172.037H138.263Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.272 172.037V170.514H139.505V172.037H139.272Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.263 175.155V173.633H138.496V175.155H138.263Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.272 175.155V173.633H139.505V175.155H139.272Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.263 177.695V176.173H138.496V177.695H138.263Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.272 177.695V176.173H139.505V177.695H139.272Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.433 141.217V139.694H134.667V141.217H134.433Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.443 141.217V139.694H135.676V141.217H135.443Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.433 143.757V142.234H134.667V143.757H134.433Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.443 143.757V142.234H135.676V143.757H135.443Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.433 146.871V145.349H134.667V146.871H134.433Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.443 146.871V145.349H135.676V146.871H135.443Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.433 149.411V147.889H134.667V149.411H134.433Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.443 149.411V147.889H135.676V149.411H135.443Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.433 152.53V151.007H134.667V152.53H134.433Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.443 152.53V151.007H135.676V152.53H135.443Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.433 155.069V153.547H134.667V155.069H134.433Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.443 155.069V153.547H135.676V155.069H135.443Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.433 158.184V156.662H134.667V158.184H134.433Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.443 158.184V156.662H135.676V158.184H135.443Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.433 160.724V159.202H134.667V160.724H134.433Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.443 160.724V159.202H135.676V160.724H135.443Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.433 163.842V162.32H134.667V163.842H134.433Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.443 163.842V162.32H135.676V163.842H135.443Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.433 166.382V164.86H134.667V166.382H134.433Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.443 166.382V164.86H135.676V166.382H135.443Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.433 169.497V167.975H134.667V169.497H134.433Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.443 169.497V167.975H135.676V169.497H135.443Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.433 172.037V170.514H134.667V172.037H134.433Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.443 172.037V170.514H135.676V172.037H135.443Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.433 175.155V173.633H134.667V175.155H134.433Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.443 175.155V173.633H135.676V175.155H135.443Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.433 177.695V176.173H134.667V177.695H134.433Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.443 177.695V176.173H135.676V177.695H135.443Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.461 141.217V139.694H130.694V141.217H130.461Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.474 141.217V139.694H131.707V141.217H131.474Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.461 143.757V142.234H130.694V143.757H130.461Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.474 143.757V142.234H131.707V143.757H131.474Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.461 146.871V145.349H130.694V146.871H130.461Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.474 146.871V145.349H131.707V146.871H131.474Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.461 149.411V147.889H130.694V149.411H130.461Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.474 149.411V147.889H131.707V149.411H131.474Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.461 152.53V151.007H130.694V152.53H130.461Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.474 152.53V151.007H131.707V152.53H131.474Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.461 155.069V153.547H130.694V155.069H130.461Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.474 155.069V153.547H131.707V155.069H131.474Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.461 158.184V156.662H130.694V158.184H130.461Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.474 158.184V156.662H131.707V158.184H131.474Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.461 160.724V159.202H130.694V160.724H130.461Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.474 160.724V159.202H131.707V160.724H131.474Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.461 163.842V162.32H130.694V163.842H130.461Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.474 163.842V162.32H131.707V163.842H131.474Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.461 166.382V164.86H130.694V166.382H130.461Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.474 166.382V164.86H131.707V166.382H131.474Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.461 169.497V167.975H130.694V169.497H130.461Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.474 169.497V167.975H131.707V169.497H131.474Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.461 172.037V170.514H130.694V172.037H130.461Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.474 172.037V170.514H131.707V172.037H131.474Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.461 175.155V173.633H130.694V175.155H130.461Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.474 175.155V173.633H131.707V175.155H131.474Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.461 177.695V176.173H130.694V177.695H130.461Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.474 177.695V176.173H131.707V177.695H131.474Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.643 141.217V139.694H126.876V141.217H126.643Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.653 141.217V139.694H127.886V141.217H127.653Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.643 143.757V142.234H126.876V143.757H126.643Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.653 143.757V142.234H127.886V143.757H127.653Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.643 146.871V145.349H126.876V146.871H126.643Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.653 146.871V145.349H127.886V146.871H127.653Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.643 149.411V147.889H126.876V149.411H126.643Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.653 149.411V147.889H127.886V149.411H127.653Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.643 152.53V151.007H126.876V152.53H126.643Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.653 152.53V151.007H127.886V152.53H127.653Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.643 155.069V153.547H126.876V155.069H126.643Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.653 155.069V153.547H127.886V155.069H127.653Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.643 158.184V156.662H126.876V158.184H126.643Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.653 158.184V156.662H127.886V158.184H127.653Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.643 160.724V159.202H126.876V160.724H126.643Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.653 160.724V159.202H127.886V160.724H127.653Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.643 163.842V162.32H126.876V163.842H126.643Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.653 163.842V162.32H127.886V163.842H127.653Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.643 166.382V164.86H126.876V166.382H126.643Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.653 166.382V164.86H127.886V166.382H127.653Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.643 169.497V167.975H126.876V169.497H126.643Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.653 169.497V167.975H127.886V169.497H127.653Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.643 172.037V170.514H126.876V172.037H126.643Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.653 172.037V170.514H127.886V172.037H127.653Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.643 175.155V173.633H126.876V175.155H126.643Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.653 175.155V173.633H127.886V175.155H127.653Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.643 177.695V176.173H126.876V177.695H126.643Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.653 177.695V176.173H127.886V177.695H127.653Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67 141.217V139.694H122.903V141.217H122.67Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.684 141.217V139.694H123.917V141.217H123.684Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67 143.757V142.234H122.903V143.757H122.67Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.684 143.757V142.234H123.917V143.757H123.684Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67 146.871V145.349H122.903V146.871H122.67Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.684 146.871V145.349H123.917V146.871H123.684Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67 149.411V147.889H122.903V149.411H122.67Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.684 149.411V147.889H123.917V149.411H123.684Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67 152.53V151.007H122.903V152.53H122.67Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.684 152.53V151.007H123.917V152.53H123.684Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67 155.069V153.547H122.903V155.069H122.67Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.684 155.069V153.547H123.917V155.069H123.684Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67 158.184V156.662H122.903V158.184H122.67Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.684 158.184V156.662H123.917V158.184H123.684Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67 160.724V159.202H122.903V160.724H122.67Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.684 160.724V159.202H123.917V160.724H123.684Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67 163.842V162.32H122.903V163.842H122.67Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.684 163.842V162.32H123.917V163.842H123.684Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67 166.382V164.86H122.903V166.382H122.67Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.684 166.382V164.86H123.917V166.382H123.684Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67 169.497V167.975H122.903V169.497H122.67Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.684 169.497V167.975H123.917V169.497H123.684Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67 172.037V170.514H122.903V172.037H122.67Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.684 172.037V170.514H123.917V172.037H123.684Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67 175.155V173.633H122.903V175.155H122.67Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.684 175.155V173.633H123.917V175.155H123.684Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67 177.695V176.173H122.903V177.695H122.67Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.684 177.695V176.173H123.917V177.695H123.684Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.268 139.209V137.687H113.501V139.209H113.268Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.268 141.749V140.227H113.501V141.749H113.268Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.268 144.867V143.345H113.501V144.867H113.268Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.268 147.403V145.881H113.501V147.403H113.268Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.268 150.522V148.999H113.501V150.522H113.268Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.268 153.062V151.539H113.501V153.062H113.268Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.268 156.18V154.658H113.501V156.18H113.268Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.268 158.716V157.194H113.501V158.716H113.268Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.268 161.835V160.312H113.501V161.835H113.268Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.268 164.374V162.852H113.501V164.374H113.268Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.268 167.493V165.971H113.501V167.493H113.268Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.268 170.029V168.507H113.501V170.029H113.268Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.268 173.147V171.625H113.501V173.147H113.268Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.268 175.687V174.165H113.501V175.687H113.268Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.422 141.353V139.694H146.923V141.353H146.422Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.422 144.382V142.724H146.923V144.382H146.422Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.422 147.407V145.749H146.923V147.407H146.422Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.422 150.436V148.778H146.923V150.436H146.422Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.422 153.466V151.807H146.923V153.466H146.422Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.422 156.495V154.836H146.923V156.495H146.422Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.422 159.52V157.862H146.923V159.52H146.422Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.422 162.549V160.891H146.923V162.549H146.422Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.422 168.607V166.949H146.923V168.607H146.422Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.422 171.637V169.978H146.923V171.637H146.422Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.422 174.662V173.004H146.923V174.662H146.422Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.422 177.691V176.033H146.923V177.691H146.422Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.422 165.578V163.92H146.923V165.578H146.422Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.158 141.353V139.694H120.659V141.353H120.158Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.158 144.382V142.724H120.659V144.382H120.158Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.158 147.407V145.749H120.659V147.407H120.158Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.158 150.436V148.778H120.659V150.436H120.158Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.158 153.466V151.807H120.659V153.466H120.158Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.158 156.495V154.836H120.659V156.495H120.158Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.158 159.52V157.862H120.659V159.52H120.158Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.158 162.549V160.891H120.659V162.549H120.158Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.158 168.607V166.949H120.659V168.607H120.158Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.158 171.637V169.978H120.659V171.637H120.158Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.158 174.662V173.004H120.659V174.662H120.158Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.158 177.691V176.033H120.659V177.691H120.158Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.158 165.578V163.92H120.659V165.578H120.158Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2059 181.334V136.79H110.212V181.334H93.2059Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1535 138.312V136.79H98.3865V138.312H98.1535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1671 138.312V136.79H99.4001V138.312H99.1671Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1535 140.852V139.329H98.3865V140.852H98.1535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1671 140.852V139.329H99.4001V140.852H99.1671Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1535 143.97V142.448H98.3865V143.97H98.1535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1671 143.97V142.448H99.4001V143.97H99.1671Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1535 146.51V144.988H98.3865V146.51H98.1535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1671 146.51V144.988H99.4001V146.51H99.1671Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1535 149.625V148.102H98.3865V149.625H98.1535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1671 149.625V148.102H99.4001V149.625H99.1671Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1535 152.165V150.642H98.3865V152.165H98.1535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1671 152.165V150.642H99.4001V152.165H99.1671Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1535 155.283V153.761H98.3865V155.283H98.1535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1671 155.283V153.761H99.4001V155.283H99.1671Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1535 157.823V156.301H98.3865V157.823H98.1535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1671 157.823V156.301H99.4001V157.823H99.1671Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1535 160.937V159.415H98.3865V160.937H98.1535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1671 160.937V159.415H99.4001V160.937H99.1671Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1535 163.477V161.955H98.3865V163.477H98.1535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1671 163.477V161.955H99.4001V163.477H99.1671Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1535 166.596V165.074H98.3865V166.596H98.1535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1671 166.596V165.074H99.4001V166.596H99.1671Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1535 169.136V167.613H98.3865V169.136H98.1535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1671 169.136V167.613H99.4001V169.136H99.1671Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1535 172.25V170.728H98.3865V172.25H98.1535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1671 172.25V170.728H99.4001V172.25H99.1671Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1535 174.79V173.268H98.3865V174.79H98.1535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1671 174.79V173.268H99.4001V174.79H99.1671Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.703 138.312V136.79H103.936V138.312H103.703Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.713 138.312V136.79H104.946V138.312H104.713Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.703 140.852V139.329H103.936V140.852H103.703Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.713 140.852V139.329H104.946V140.852H104.713Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.703 143.97V142.448H103.936V143.97H103.703Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.713 143.97V142.448H104.946V143.97H104.713Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.703 146.51V144.988H103.936V146.51H103.703Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.713 146.51V144.988H104.946V146.51H104.713Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.703 149.625V148.102H103.936V149.625H103.703Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.713 149.625V148.102H104.946V149.625H104.713Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.703 152.165V150.642H103.936V152.165H103.703Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.713 152.165V150.642H104.946V152.165H104.713Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.703 155.283V153.761H103.936V155.283H103.703Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.713 155.283V153.761H104.946V155.283H104.713Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.703 157.823V156.301H103.936V157.823H103.703Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.713 157.823V156.301H104.946V157.823H104.713Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.703 160.937V159.415H103.936V160.937H103.703Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.713 160.937V159.415H104.946V160.937H104.713Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.703 163.477V161.955H103.936V163.477H103.703Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.713 163.477V161.955H104.946V163.477H104.713Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.703 166.596V165.074H103.936V166.596H103.703Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.713 166.596V165.074H104.946V166.596H104.713Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.703 169.136V167.613H103.936V169.136H103.703Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.713 169.136V167.613H104.946V169.136H104.713Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.703 172.25V170.728H103.936V172.25H103.703Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.713 172.25V170.728H104.946V172.25H104.713Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.703 174.79V173.268H103.936V174.79H103.703Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.713 174.79V173.268H104.946V174.79H104.713Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0447 138.312V136.79H96.2777V138.312H96.0447Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0447 140.852V139.329H96.2777V140.852H96.0447Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0447 143.97V142.448H96.2777V143.97H96.0447Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0447 146.51V144.988H96.2777V146.51H96.0447Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0447 149.625V148.102H96.2777V149.625H96.0447Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0447 152.165V150.642H96.2777V152.165H96.0447Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0447 155.283V153.761H96.2777V155.283H96.0447Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0447 157.823V156.301H96.2777V157.823H96.0447Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0447 160.937V159.415H96.2777V160.937H96.0447Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0447 163.477V161.955H96.2777V163.477H96.0447Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0447 166.596V165.074H96.2777V166.596H96.0447Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0447 169.136V167.613H96.2777V169.136H96.0447Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0447 172.25V170.728H96.2777V172.25H96.0447Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0447 174.79V173.268H96.2777V174.79H96.0447Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.513 138.312V136.79H101.746V138.312H101.513Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.513 140.852V139.329H101.746V140.852H101.513Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.513 143.97V142.448H101.746V143.97H101.513Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.513 146.51V144.988H101.746V146.51H101.513Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.513 149.625V148.102H101.746V149.625H101.513Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.513 152.165V150.642H101.746V152.165H101.513Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.513 155.283V153.761H101.746V155.283H101.513Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.513 157.823V156.301H101.746V157.823H101.513Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.513 160.937V159.415H101.746V160.937H101.513Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.513 163.477V161.955H101.746V163.477H101.513Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.513 166.596V165.074H101.746V166.596H101.513Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.513 169.136V167.613H101.746V169.136H101.513Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.513 172.25V170.728H101.746V172.25H101.513Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.513 174.79V173.268H101.746V174.79H101.513Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.86 138.312V136.79H107.093V138.312H106.86Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.86 140.852V139.329H107.093V140.852H106.86Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.86 143.97V142.448H107.093V143.97H106.86Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.86 146.51V144.988H107.093V146.51H106.86Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.86 149.625V148.102H107.093V149.625H106.86Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.86 152.165V150.642H107.093V152.165H106.86Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.86 155.283V153.761H107.093V155.283H106.86Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.86 157.823V156.301H107.093V157.823H106.86Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.86 160.937V159.415H107.093V160.937H106.86Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.86 163.477V161.955H107.093V163.477H106.86Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.86 166.596V165.074H107.093V166.596H106.86Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.86 169.136V167.613H107.093V169.136H106.86Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.86 172.25V170.728H107.093V172.25H106.86Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.86 174.79V173.268H107.093V174.79H106.86Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.563 137.71V135.38H154.488V137.71H119.563Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.717 135.228V131.019H148.632V135.228H144.717Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.294 130.634V130.498H148.95V130.634H144.294Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.138 129.958V127.702H147.133V129.958H146.138Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.138 134.001V131.745H147.133V134.001H146.138Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6622 134.199V120.953H108.445V134.199H96.6622Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.126 115.857V110.37H104.985V115.857H100.126Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.423 109.376V105.818H103.684V109.376H101.423Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.903 116.719L108.494 118.087H96.6047L96.1148 116.719H108.903Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.037 119.683V119.535H109.202V119.683H96.037Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.598 134.195V127.768H118.441V134.195H109.598Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.554 117.714L102.554 117.714C102.994 117.713 103.43 117.8 103.837 117.968C104.244 118.136 104.614 118.383 104.926 118.694C105.238 119.005 105.485 119.375 105.653 119.782C105.822 120.189 105.909 120.625 105.909 121.065L105.909 121.065C105.91 121.729 105.713 122.378 105.345 122.931C104.977 123.483 104.453 123.914 103.84 124.168C103.227 124.423 102.552 124.49 101.901 124.36C101.25 124.231 100.652 123.912 100.182 123.443C99.7126 122.974 99.3927 122.376 99.2629 121.725C99.1331 121.074 99.1994 120.399 99.4532 119.786C99.7071 119.173 100.137 118.648 100.689 118.279C101.241 117.911 101.89 117.714 102.554 117.714ZM101.151 123.164C101.566 123.442 102.054 123.59 102.554 123.59C103.223 123.59 103.865 123.324 104.338 122.85C104.812 122.377 105.078 121.735 105.078 121.065C105.078 120.566 104.93 120.078 104.652 119.663C104.375 119.248 103.981 118.924 103.52 118.733C103.058 118.542 102.551 118.492 102.061 118.589C101.571 118.687 101.122 118.927 100.769 119.28C100.416 119.633 100.175 120.083 100.078 120.573C99.9803 121.062 100.03 121.57 100.221 122.031C100.412 122.493 100.736 122.887 101.151 123.164Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.89 131.143V129.325H114.142V131.143H113.89Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.266 131.143V129.325H112.519V131.143H112.266Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.478 131.143V129.325H115.73V131.143H115.478Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-810-inside-1_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.3729 126.762H97.0156V130.564H97.3729V126.762Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M97.3729 126.762H97.0156V130.564H97.3729V126.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0156 126.762V126.374H96.6272V126.762H97.0156ZM97.3729 126.762H97.7612V126.374H97.3729V126.762ZM97.3729 130.564V130.953H97.7612V130.564H97.3729ZM97.0156 130.564H96.6272V130.953H97.0156V130.564ZM97.0156 127.151H97.3729V126.374H97.0156V127.151ZM96.9845 126.762V130.564H97.7612V126.762H96.9845ZM97.3729 130.176H97.0156V130.953H97.3729V130.176ZM97.4039 130.564V126.762H96.6272V130.564H97.4039Z",
    fill: "#C9C5C5",
    mask: "url(#path-810-inside-1_1_638)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-812-inside-2_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.7593 126.762H98.402V130.564H98.7593V126.762Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.7593 126.762H98.402V130.564H98.7593V126.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.402 126.762V126.374H98.0137V126.762H98.402ZM98.7593 126.762H99.1476V126.374H98.7593V126.762ZM98.7593 130.564V130.953H99.1476V130.564H98.7593ZM98.402 130.564H98.0137V130.953H98.402V130.564ZM98.402 127.151H98.7593V126.374H98.402V127.151ZM98.3709 126.762V130.564H99.1476V126.762H98.3709ZM98.7593 130.176H98.402V130.953H98.7593V130.176ZM98.7904 130.564V126.762H98.0137V130.564H98.7904Z",
    fill: "#C9C5C5",
    mask: "url(#path-812-inside-2_1_638)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-814-inside-3_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.165 126.762H99.8079V130.564H100.165V126.762Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.165 126.762H99.8079V130.564H100.165V126.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8079 126.762V126.374H99.4195V126.762H99.8079ZM100.165 126.762H100.554V126.374H100.165V126.762ZM100.165 130.564V130.953H100.554V130.564H100.165ZM99.8079 130.564H99.4195V130.953H99.8079V130.564ZM99.8079 127.151H100.165V126.374H99.8079V127.151ZM99.7768 126.762V130.564H100.554V126.762H99.7768ZM100.165 130.176H99.8079V130.953H100.165V130.176ZM100.196 130.564V126.762H99.4195V130.564H100.196Z",
    fill: "#C9C5C5",
    mask: "url(#path-814-inside-3_1_638)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-816-inside-4_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.3729 121.955H97.0156V125.757H97.3729V121.955Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M97.3729 121.955H97.0156V125.757H97.3729V121.955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0156 121.955V121.566H96.6272V121.955H97.0156ZM97.3729 121.955H97.7612V121.566H97.3729V121.955ZM97.3729 125.757V126.145H97.7612V125.757H97.3729ZM97.0156 125.757H96.6272V126.145H97.0156V125.757ZM97.0156 122.343H97.3729V121.566H97.0156V122.343ZM96.9845 121.955V125.757H97.7612V121.955H96.9845ZM97.3729 125.368H97.0156V126.145H97.3729V125.368ZM97.4039 125.757V121.955H96.6272V125.757H97.4039Z",
    fill: "#C9C5C5",
    mask: "url(#path-816-inside-4_1_638)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-818-inside-5_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.7593 121.955H98.402V125.757H98.7593V121.955Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.7593 121.955H98.402V125.757H98.7593V121.955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.402 121.955V121.566H98.0137V121.955H98.402ZM98.7593 121.955H99.1476V121.566H98.7593V121.955ZM98.7593 125.757V126.145H99.1476V125.757H98.7593ZM98.402 125.757H98.0137V126.145H98.402V125.757ZM98.402 122.343H98.7593V121.566H98.402V122.343ZM98.3709 121.955V125.757H99.1476V121.955H98.3709ZM98.7593 125.368H98.402V126.145H98.7593V125.368ZM98.7904 125.757V121.955H98.0137V125.757H98.7904Z",
    fill: "#C9C5C5",
    mask: "url(#path-818-inside-5_1_638)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-820-inside-6_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.754 130.564H108.111V126.762H107.754V130.564Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.754 130.564H108.111V126.762H107.754V130.564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.111 130.564V130.953H108.499V130.564H108.111ZM107.754 130.564H107.365V130.953H107.754V130.564ZM107.754 126.762V126.374H107.365V126.762H107.754ZM108.111 126.762H108.499V126.374H108.111V126.762ZM108.111 130.176H107.754V130.953H108.111V130.176ZM108.142 130.564V126.762H107.365V130.564H108.142ZM107.754 127.151H108.111V126.374H107.754V127.151ZM107.723 126.762V130.564H108.499V126.762H107.723Z",
    fill: "#C9C5C5",
    mask: "url(#path-820-inside-6_1_638)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-822-inside-7_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.367 130.564H106.724V126.762H106.367V130.564Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.367 130.564H106.724V126.762H106.367V130.564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.724 130.564V130.953H107.113V130.564H106.724ZM106.367 130.564H105.979V130.953H106.367V130.564ZM106.367 126.762V126.374H105.979V126.762H106.367ZM106.724 126.762H107.113V126.374H106.724V126.762ZM106.724 130.176H106.367V130.953H106.724V130.176ZM106.756 130.564V126.762H105.979V130.564H106.756ZM106.367 127.151H106.724V126.374H106.367V127.151ZM106.336 126.762V130.564H107.113V126.762H106.336Z",
    fill: "#C9C5C5",
    mask: "url(#path-822-inside-7_1_638)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-824-inside-8_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.961 130.564H105.319V126.762H104.961V130.564Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104.961 130.564H105.319V126.762H104.961V130.564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.319 130.564V130.953H105.707V130.564H105.319ZM104.961 130.564H104.573V130.953H104.961V130.564ZM104.961 126.762V126.374H104.573V126.762H104.961ZM105.319 126.762H105.707V126.374H105.319V126.762ZM105.319 130.176H104.961V130.953H105.319V130.176ZM105.35 130.564V126.762H104.573V130.564H105.35ZM104.961 127.151H105.319V126.374H104.961V127.151ZM104.93 126.762V130.564H105.707V126.762H104.93Z",
    fill: "#C9C5C5",
    mask: "url(#path-824-inside-8_1_638)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-826-inside-9_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.754 125.757H108.111V121.955H107.754V125.757Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.754 125.757H108.111V121.955H107.754V125.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.111 125.757V126.145H108.499V125.757H108.111ZM107.754 125.757H107.365V126.145H107.754V125.757ZM107.754 121.955V121.566H107.365V121.955H107.754ZM108.111 121.955H108.499V121.566H108.111V121.955ZM108.111 125.368H107.754V126.145H108.111V125.368ZM108.142 125.757V121.955H107.365V125.757H108.142ZM107.754 122.343H108.111V121.566H107.754V122.343ZM107.723 121.955V125.757H108.499V121.955H107.723Z",
    fill: "#C9C5C5",
    mask: "url(#path-826-inside-9_1_638)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-828-inside-10_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.367 125.757H106.724V121.955H106.367V125.757Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.367 125.757H106.724V121.955H106.367V125.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.724 125.757V126.145H107.113V125.757H106.724ZM106.367 125.757H105.979V126.145H106.367V125.757ZM106.367 121.955V121.566H105.979V121.955H106.367ZM106.724 121.955H107.113V121.566H106.724V121.955ZM106.724 125.368H106.367V126.145H106.724V125.368ZM106.756 125.757V121.955H105.979V125.757H106.756ZM106.367 122.343H106.724V121.566H106.367V122.343ZM106.336 121.955V125.757H107.113V121.955H106.336Z",
    fill: "#C9C5C5",
    mask: "url(#path-828-inside-10_1_638)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.282 130.37V126.957H102.709V130.37H102.282Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.824 132.686V134.199H119.567V131.146L121.824 132.686Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0862 134.199L91.5062 132.778H95.4622V134.199H93.0862Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.381 114.362V111.791H101.703V114.362H101.381Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.361 114.362V111.791H103.684V114.362H103.361Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.437 108.584V106.797H102.569V108.584H102.437Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.383 124.568V120.953H115.567V124.568H112.383Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.268 119.788V117.488H114.686V119.788H113.268Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.735 125.279L118.464 126.087H109.532L109.209 125.279H118.735Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.172 116.292L114.757 117.1H113.185L112.768 116.292H115.172Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.337 104.626L103.776 105.43H101.326L100.763 104.626H104.337Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-841-inside-11_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.635 126.634H109.404V126.999H118.635V126.634Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.635 126.634H109.404V126.999H118.635V126.634Z",
    fill: "#88898D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.404 126.634V126.246H109.016V126.634H109.404ZM118.635 126.634H119.024V126.246H118.635V126.634ZM118.635 126.999V127.388H119.024V126.999H118.635ZM109.404 126.999H109.016V127.388H109.404V126.999ZM109.404 127.023H118.635V126.246H109.404V127.023ZM118.247 126.634V126.999H119.024V126.634H118.247ZM118.635 126.611H109.404V127.388H118.635V126.611ZM109.792 126.999V126.634H109.016V126.999H109.792Z",
    fill: "#C9C5C5",
    mask: "url(#path-841-inside-11_1_638)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.237 123.551V121.923H113.334V123.551H113.237Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.589 123.551V121.923H114.686V123.551H114.589Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-845-inside-12_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.119 117.958H113.761V119.438H114.119V117.958Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.119 117.958H113.761V119.438H114.119V117.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.761 117.958V117.57H113.373V117.958H113.761ZM114.119 117.958H114.507V117.57H114.119V117.958ZM114.119 119.438V119.826H114.507V119.438H114.119ZM113.761 119.438H113.373V119.826H113.761V119.438ZM113.761 118.347H114.119V117.57H113.761V118.347ZM113.73 117.958V119.438H114.507V117.958H113.73ZM114.119 119.05H113.761V119.826H114.119V119.05ZM114.15 119.438V117.958H113.373V119.438H114.15Z",
    fill: "#C9C5C5",
    mask: "url(#path-845-inside-12_1_638)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.666 136.79V181.819H240.559V139.02L243.216 136.79H247.666Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.37 139.124V181.819H204.508V139.124H209.37Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.437 147.306V147.9H239.231V147.306H239.437Z",
    fill: "#FFEF0C",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.434 141.531V140.009H208.667V141.531H208.434Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.421 141.531V140.009H207.654V141.531H207.421Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.298 141.531V140.009H206.531V141.531H206.298Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.285 141.531V140.009H205.518V141.531H205.285Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.434 144.071V142.549H208.667V144.071H208.434Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.421 144.071V142.549H207.654V144.071H207.421Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.298 144.071V142.549H206.531V144.071H206.298Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.285 144.071V142.549H205.518V144.071H205.285Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.434 147.186V145.664H208.667V147.186H208.434Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.421 147.186V145.664H207.654V147.186H207.421Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.298 147.186V145.664H206.531V147.186H206.298Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.285 147.186V145.664H205.518V147.186H205.285Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.434 149.726V148.203H208.667V149.726H208.434Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.421 149.726V148.203H207.654V149.726H207.421Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.298 149.726V148.203H206.531V149.726H206.298Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.285 149.726V148.203H205.518V149.726H205.285Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.434 152.844V151.322H208.667V152.844H208.434Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.421 152.844V151.322H207.654V152.844H207.421Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.298 152.844V151.322H206.531V152.844H206.298Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.285 152.844V151.322H205.518V152.844H205.285Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.434 155.384V153.862H208.667V155.384H208.434Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.421 155.384V153.862H207.654V155.384H207.421Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.298 155.384V153.862H206.531V155.384H206.298Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.285 155.384V153.862H205.518V155.384H205.285Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.434 158.499V156.976H208.667V158.499H208.434Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.421 158.499V156.976H207.654V158.499H207.421Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.298 158.499V156.976H206.531V158.499H206.298Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.285 158.499V156.976H205.518V158.499H205.285Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.434 161.038V159.516H208.667V161.038H208.434Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.421 161.038V159.516H207.654V161.038H207.421Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.298 161.038V159.516H206.531V161.038H206.298Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.285 161.038V159.516H205.518V161.038H205.285Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.434 164.157V162.635H208.667V164.157H208.434Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.421 164.157V162.635H207.654V164.157H207.421Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.298 164.157V162.635H206.531V164.157H206.298Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.285 164.157V162.635H205.518V164.157H205.285Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.434 166.693V165.171H208.667V166.693H208.434Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.421 166.693V165.171H207.654V166.693H207.421Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.298 166.693V165.171H206.531V166.693H206.298Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.285 166.693V165.171H205.518V166.693H205.285Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.434 169.811V168.289H208.667V169.811H208.434Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.421 169.811V168.289H207.654V169.811H207.421Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.298 169.811V168.289H206.531V169.811H206.298Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.285 169.811V168.289H205.518V169.811H205.285Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.434 172.351V170.829H208.667V172.351H208.434Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.421 172.351V170.829H207.654V172.351H207.421Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.298 172.351V170.829H206.531V172.351H206.298Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.285 172.351V170.829H205.518V172.351H205.285Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.434 175.47V173.947H208.667V175.47H208.434Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.421 175.47V173.947H207.654V175.47H207.421Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.298 175.47V173.947H206.531V175.47H206.298Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.285 175.47V173.947H205.518V175.47H205.285Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.434 178.006V176.483H208.667V178.006H208.434Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.421 178.006V176.483H207.654V178.006H207.421Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.298 178.006V176.483H206.531V178.006H206.298Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.285 178.006V176.483H205.518V178.006H205.285Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.433 139.124V181.819H210.349V139.124H239.433Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.535 141.217V139.694H216.768V141.217H216.535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.526 141.217V139.694H215.759V141.217H215.526Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.535 143.757V142.234H216.768V143.757H216.535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.526 143.757V142.234H215.759V143.757H215.526Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.535 146.871V145.349H216.768V146.871H216.535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.526 146.871V145.349H215.759V146.871H215.526Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.535 149.411V147.889H216.768V149.411H216.535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.526 149.411V147.889H215.759V149.411H215.526Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.535 152.53V151.007H216.768V152.53H216.535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.526 152.53V151.007H215.759V152.53H215.526Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.535 155.069V153.547H216.768V155.069H216.535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.526 155.069V153.547H215.759V155.069H215.526Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.535 158.184V156.662H216.768V158.184H216.535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.526 158.184V156.662H215.759V158.184H215.526Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.535 160.724V159.202H216.768V160.724H216.535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.526 160.724V159.202H215.759V160.724H215.526Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.535 163.842V162.32H216.768V163.842H216.535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.526 163.842V162.32H215.759V163.842H215.526Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.535 166.382V164.86H216.768V166.382H216.535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.526 166.382V164.86H215.759V166.382H215.526Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.535 169.497V167.975H216.768V169.497H216.535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.526 169.497V167.975H215.759V169.497H215.526Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.535 172.037V170.514H216.768V172.037H216.535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.526 172.037V170.514H215.759V172.037H215.526Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.535 175.155V173.633H216.768V175.155H216.535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.526 175.155V173.633H215.759V175.155H215.526Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.535 177.695V176.173H216.768V177.695H216.535Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.526 177.695V176.173H215.759V177.695H215.526Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.508 141.217V139.694H220.741V141.217H220.508Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.495 141.217V139.694H219.728V141.217H219.495Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.508 143.757V142.234H220.741V143.757H220.508Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.495 143.757V142.234H219.728V143.757H219.495Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.508 146.871V145.349H220.741V146.871H220.508Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.495 146.871V145.349H219.728V146.871H219.495Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.508 149.411V147.889H220.741V149.411H220.508Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.495 149.411V147.889H219.728V149.411H219.495Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.508 152.53V151.007H220.741V152.53H220.508Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.495 152.53V151.007H219.728V152.53H219.495Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.508 155.069V153.547H220.741V155.069H220.508Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.495 155.069V153.547H219.728V155.069H219.495Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.508 158.184V156.662H220.741V158.184H220.508Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.495 158.184V156.662H219.728V158.184H219.495Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.508 160.724V159.202H220.741V160.724H220.508Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.495 160.724V159.202H219.728V160.724H219.495Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.508 163.842V162.32H220.741V163.842H220.508Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.495 163.842V162.32H219.728V163.842H219.495Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.508 166.382V164.86H220.741V166.382H220.508Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.495 166.382V164.86H219.728V166.382H219.495Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.508 169.497V167.975H220.741V169.497H220.508Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.495 169.497V167.975H219.728V169.497H219.495Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.508 172.037V170.514H220.741V172.037H220.508Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.495 172.037V170.514H219.728V172.037H219.495Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.508 175.155V173.633H220.741V175.155H220.508Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.495 175.155V173.633H219.728V175.155H219.495Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.508 177.695V176.173H220.741V177.695H220.508Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.495 177.695V176.173H219.728V177.695H219.495Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.333 141.217V139.694H224.567V141.217H224.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.324 141.217V139.694H223.557V141.217H223.324Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.333 143.757V142.234H224.567V143.757H224.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.324 143.757V142.234H223.557V143.757H223.324Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.333 146.871V145.349H224.567V146.871H224.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.324 146.871V145.349H223.557V146.871H223.324Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.333 149.411V147.889H224.567V149.411H224.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.324 149.411V147.889H223.557V149.411H223.324Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.333 152.53V151.007H224.567V152.53H224.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.324 152.53V151.007H223.557V152.53H223.324Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.333 155.069V153.547H224.567V155.069H224.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.324 155.069V153.547H223.557V155.069H223.324Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.333 158.184V156.662H224.567V158.184H224.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.324 158.184V156.662H223.557V158.184H223.324Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.333 160.724V159.202H224.567V160.724H224.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.324 160.724V159.202H223.557V160.724H223.324Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.333 163.842V162.32H224.567V163.842H224.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.324 163.842V162.32H223.557V163.842H223.324Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.333 166.382V164.86H224.567V166.382H224.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.324 166.382V164.86H223.557V166.382H223.324Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.333 169.497V167.975H224.567V169.497H224.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.324 169.497V167.975H223.557V169.497H223.324Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.333 172.037V170.514H224.567V172.037H224.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.324 172.037V170.514H223.557V172.037H223.324Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.333 175.155V173.633H224.567V175.155H224.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.324 175.155V173.633H223.557V175.155H223.324Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.333 177.695V176.173H224.567V177.695H224.333Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.324 177.695V176.173H223.557V177.695H223.324Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.306 141.217V139.694H228.539V141.217H228.306Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.293 141.217V139.694H227.526V141.217H227.293Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.306 143.757V142.234H228.539V143.757H228.306Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.293 143.757V142.234H227.526V143.757H227.293Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.306 146.871V145.349H228.539V146.871H228.306Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.293 146.871V145.349H227.526V146.871H227.293Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.306 149.411V147.889H228.539V149.411H228.306Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.293 149.411V147.889H227.526V149.411H227.293Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.306 152.53V151.007H228.539V152.53H228.306Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.293 152.53V151.007H227.526V152.53H227.293Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.306 155.069V153.547H228.539V155.069H228.306Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.293 155.069V153.547H227.526V155.069H227.293Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.306 158.184V156.662H228.539V158.184H228.306Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.293 158.184V156.662H227.526V158.184H227.293Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.306 160.724V159.202H228.539V160.724H228.306Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.293 160.724V159.202H227.526V160.724H227.293Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.306 163.842V162.32H228.539V163.842H228.306Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.293 163.842V162.32H227.526V163.842H227.293Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.306 166.382V164.86H228.539V166.382H228.306Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.293 166.382V164.86H227.526V166.382H227.293Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.306 169.497V167.975H228.539V169.497H228.306Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.293 169.497V167.975H227.526V169.497H227.293Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.306 172.037V170.514H228.539V172.037H228.306Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.293 172.037V170.514H227.526V172.037H227.293Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.306 175.155V173.633H228.539V175.155H228.306Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.293 175.155V173.633H227.526V175.155H227.293Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.306 177.695V176.173H228.539V177.695H228.306Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.293 177.695V176.173H227.526V177.695H227.293Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.128 141.217V139.694H232.361V141.217H232.128Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.114 141.217V139.694H231.347V141.217H231.114Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.128 143.757V142.234H232.361V143.757H232.128Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.114 143.757V142.234H231.347V143.757H231.114Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.128 146.871V145.349H232.361V146.871H232.128Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.114 146.871V145.349H231.347V146.871H231.114Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.128 149.411V147.889H232.361V149.411H232.128Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.114 149.411V147.889H231.347V149.411H231.114Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.128 152.53V151.007H232.361V152.53H232.128Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.114 152.53V151.007H231.347V152.53H231.114Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.128 155.069V153.547H232.361V155.069H232.128Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.114 155.069V153.547H231.347V155.069H231.114Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.128 158.184V156.662H232.361V158.184H232.128Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.114 158.184V156.662H231.347V158.184H231.114Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.128 160.724V159.202H232.361V160.724H232.128Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.114 160.724V159.202H231.347V160.724H231.114Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.128 163.842V162.32H232.361V163.842H232.128Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.114 163.842V162.32H231.347V163.842H231.114Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.128 166.382V164.86H232.361V166.382H232.128Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.114 166.382V164.86H231.347V166.382H231.114Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.128 169.497V167.975H232.361V169.497H232.128Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.114 169.497V167.975H231.347V169.497H231.114Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.128 172.037V170.514H232.361V172.037H232.128Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.114 172.037V170.514H231.347V172.037H231.114Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.128 175.155V173.633H232.361V175.155H232.128Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.114 175.155V173.633H231.347V175.155H231.114Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.128 177.695V176.173H232.361V177.695H232.128Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.114 177.695V176.173H231.347V177.695H231.114Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.097 141.217V139.694H236.33V141.217H236.097Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.083 141.217V139.694H235.316V141.217H235.083Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.097 143.757V142.234H236.33V143.757H236.097Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.083 143.757V142.234H235.316V143.757H235.083Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.097 146.871V145.349H236.33V146.871H236.097Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.083 146.871V145.349H235.316V146.871H235.083Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.097 149.411V147.889H236.33V149.411H236.097Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.083 149.411V147.889H235.316V149.411H235.083Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.097 152.53V151.007H236.33V152.53H236.097Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.083 152.53V151.007H235.316V152.53H235.083Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.097 155.069V153.547H236.33V155.069H236.097Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.083 155.069V153.547H235.316V155.069H235.083Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.097 158.184V156.662H236.33V158.184H236.097Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.083 158.184V156.662H235.316V158.184H235.083Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.097 160.724V159.202H236.33V160.724H236.097Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.083 160.724V159.202H235.316V160.724H235.083Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.097 163.842V162.32H236.33V163.842H236.097Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.083 163.842V162.32H235.316V163.842H235.083Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.097 166.382V164.86H236.33V166.382H236.097Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.083 166.382V164.86H235.316V166.382H235.083Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.097 169.497V167.975H236.33V169.497H236.097Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.083 169.497V167.975H235.316V169.497H235.083Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.097 172.037V170.514H236.33V172.037H236.097Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.083 172.037V170.514H235.316V172.037H235.083Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.097 175.155V173.633H236.33V175.155H236.097Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.083 175.155V173.633H235.316V175.155H235.083Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.097 177.695V176.173H236.33V177.695H236.097Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.083 177.695V176.173H235.316V177.695H235.083Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.499 139.209V137.687H245.732V139.209H245.499Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.499 141.749V140.227H245.732V141.749H245.499Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.499 144.867V143.345H245.732V144.867H245.499Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.499 147.403V145.881H245.732V147.403H245.499Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.499 150.522V148.999H245.732V150.522H245.499Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.499 153.062V151.539H245.732V153.062H245.499Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.499 156.18V154.658H245.732V156.18H245.499Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.499 158.716V157.194H245.732V158.716H245.499Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.499 161.835V160.312H245.732V161.835H245.499Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.499 164.374V162.852H245.732V164.374H245.499Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.499 167.493V165.971H245.732V167.493H245.499Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.499 170.029V168.507H245.732V170.029H245.499Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.499 173.147V171.625H245.732V173.147H245.499Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.499 175.687V174.165H245.732V175.687H245.499Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.077 141.353V139.694H212.578V141.353H212.077Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.077 144.382V142.724H212.578V144.382H212.077Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.077 147.407V145.749H212.578V147.407H212.077Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.077 150.436V148.778H212.578V150.436H212.077Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.077 153.466V151.807H212.578V153.466H212.077Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.077 156.495V154.836H212.578V156.495H212.077Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.077 159.52V157.862H212.578V159.52H212.077Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.077 162.549V160.891H212.578V162.549H212.077Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.077 168.607V166.949H212.578V168.607H212.077Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.077 171.637V169.978H212.578V171.637H212.077Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.077 174.662V173.004H212.578V174.662H212.077Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.077 177.691V176.033H212.578V177.691H212.077Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.077 165.578V163.92H212.578V165.578H212.077Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.341 141.353V139.694H238.842V141.353H238.341Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.341 144.382V142.724H238.842V144.382H238.341Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.341 147.407V145.749H238.842V147.407H238.341Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.341 150.436V148.778H238.842V150.436H238.341Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.341 153.466V151.807H238.842V153.466H238.341Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.341 156.495V154.836H238.842V156.495H238.341Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.341 159.52V157.862H238.842V159.52H238.341Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.341 162.549V160.891H238.842V162.549H238.341Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.341 168.607V166.949H238.842V168.607H238.341Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.341 171.637V169.978H238.842V171.637H238.341Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.341 174.662V173.004H238.842V174.662H238.341Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.341 177.691V176.033H238.842V177.691H238.341Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.341 165.578V163.92H238.842V165.578H238.341Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.794 136.79V181.334H248.788V136.79H265.794Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.613 138.312V136.79H260.847V138.312H260.613Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.6 138.312V136.79H259.833V138.312H259.6Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.613 140.852V139.329H260.847V140.852H260.613Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.6 140.852V139.329H259.833V140.852H259.6Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.613 143.97V142.448H260.847V143.97H260.613Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.6 143.97V142.448H259.833V143.97H259.6Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.613 146.51V144.988H260.847V146.51H260.613Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.6 146.51V144.988H259.833V146.51H259.6Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.613 149.625V148.102H260.847V149.625H260.613Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.6 149.625V148.102H259.833V149.625H259.6Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.613 152.165V150.642H260.847V152.165H260.613Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.6 152.165V150.642H259.833V152.165H259.6Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.613 155.283V153.761H260.847V155.283H260.613Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.6 155.283V153.761H259.833V155.283H259.6Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.613 157.823V156.301H260.847V157.823H260.613Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.6 157.823V156.301H259.833V157.823H259.6Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.613 160.937V159.415H260.847V160.937H260.613Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.6 160.937V159.415H259.833V160.937H259.6Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.613 163.477V161.955H260.847V163.477H260.613Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.6 163.477V161.955H259.833V163.477H259.6Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.613 166.596V165.074H260.847V166.596H260.613Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.6 166.596V165.074H259.833V166.596H259.6Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.613 169.136V167.613H260.847V169.136H260.613Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.6 169.136V167.613H259.833V169.136H259.6Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.613 172.25V170.728H260.847V172.25H260.613Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.6 172.25V170.728H259.833V172.25H259.6Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.613 174.79V173.268H260.847V174.79H260.613Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.6 174.79V173.268H259.833V174.79H259.6Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.064 138.312V136.79H255.297V138.312H255.064Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.054 138.312V136.79H254.287V138.312H254.054Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.064 140.852V139.329H255.297V140.852H255.064Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.054 140.852V139.329H254.287V140.852H254.054Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.064 143.97V142.448H255.297V143.97H255.064Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.054 143.97V142.448H254.287V143.97H254.054Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.064 146.51V144.988H255.297V146.51H255.064Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.054 146.51V144.988H254.287V146.51H254.054Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.064 149.625V148.102H255.297V149.625H255.064Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.054 149.625V148.102H254.287V149.625H254.054Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.064 152.165V150.642H255.297V152.165H255.064Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.054 152.165V150.642H254.287V152.165H254.054Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.064 155.283V153.761H255.297V155.283H255.064Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.054 155.283V153.761H254.287V155.283H254.054Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.064 157.823V156.301H255.297V157.823H255.064Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.054 157.823V156.301H254.287V157.823H254.054Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.064 160.937V159.415H255.297V160.937H255.064Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.054 160.937V159.415H254.287V160.937H254.054Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.064 163.477V161.955H255.297V163.477H255.064Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.054 163.477V161.955H254.287V163.477H254.054Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.064 166.596V165.074H255.297V166.596H255.064Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.054 166.596V165.074H254.287V166.596H254.054Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.064 169.136V167.613H255.297V169.136H255.064Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.054 169.136V167.613H254.287V169.136H254.054Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.064 172.25V170.728H255.297V172.25H255.064Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.054 172.25V170.728H254.287V172.25H254.054Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.064 174.79V173.268H255.297V174.79H255.064Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.054 174.79V173.268H254.287V174.79H254.054Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.726 138.312V136.79H262.959V138.312H262.726Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.726 140.852V139.329H262.959V140.852H262.726Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.726 143.97V142.448H262.959V143.97H262.726Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.726 146.51V144.988H262.959V146.51H262.726Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.726 149.625V148.102H262.959V149.625H262.726Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.726 152.165V150.642H262.959V152.165H262.726Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.726 155.283V153.761H262.959V155.283H262.726Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.726 157.823V156.301H262.959V157.823H262.726Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.726 160.937V159.415H262.959V160.937H262.726Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.726 163.477V161.955H262.959V163.477H262.726Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.726 166.596V165.074H262.959V166.596H262.726Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.726 169.136V167.613H262.959V169.136H262.726Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.726 172.25V170.728H262.959V172.25H262.726Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.726 174.79V173.268H262.959V174.79H262.726Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.254 138.312V136.79H257.487V138.312H257.254Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.254 140.852V139.329H257.487V140.852H257.254Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.254 143.97V142.448H257.487V143.97H257.254Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.254 146.51V144.988H257.487V146.51H257.254Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.254 149.625V148.102H257.487V149.625H257.254Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.254 152.165V150.642H257.487V152.165H257.254Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.254 155.283V153.761H257.487V155.283H257.254Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.254 157.823V156.301H257.487V157.823H257.254Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.254 160.937V159.415H257.487V160.937H257.254Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.254 163.477V161.955H257.487V163.477H257.254Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.254 166.596V165.074H257.487V166.596H257.254Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.254 169.136V167.613H257.487V169.136H257.254Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.254 172.25V170.728H257.487V172.25H257.254Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.254 174.79V173.268H257.487V174.79H257.254Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.907 138.312V136.79H252.14V138.312H251.907Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.907 140.852V139.329H252.14V140.852H251.907Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.907 143.97V142.448H252.14V143.97H251.907Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.907 146.51V144.988H252.14V146.51H251.907Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.907 149.625V148.102H252.14V149.625H251.907Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.907 152.165V150.642H252.14V152.165H251.907Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.907 155.283V153.761H252.14V155.283H251.907Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.907 157.823V156.301H252.14V157.823H251.907Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.907 160.937V159.415H252.14V160.937H251.907Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.907 163.477V161.955H252.14V163.477H251.907Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.907 166.596V165.074H252.14V166.596H251.907Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.907 169.136V167.613H252.14V169.136H251.907Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.907 172.25V170.728H252.14V172.25H251.907Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.907 174.79V173.268H252.14V174.79H251.907Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.437 135.38V137.71H204.512V135.38H239.437Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.283 131.023V135.232H210.368V131.023H214.283Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.706 130.498V130.634H210.05V130.498H214.706Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.862 127.702V129.958H211.867V127.702H212.862Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.862 131.745V134.001H211.867V131.745H212.862Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.338 120.949V134.195H250.555V120.949H262.338Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.874 110.37V115.857H254.015V110.37H258.874Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.577 105.822V109.38H255.316V105.822H257.577Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.885 116.719L262.395 118.087H250.506L250.097 116.719H262.885Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.963 119.531V119.679H249.798V119.531H262.963Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.406 127.772V134.199H240.563V127.772H249.406Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.655 122.931C253.287 122.378 253.09 121.729 253.091 121.065C253.092 120.176 253.446 119.324 254.075 118.695C254.704 118.067 255.557 117.714 256.446 117.714C257.11 117.714 257.759 117.911 258.311 118.279C258.863 118.648 259.293 119.173 259.547 119.786C259.801 120.399 259.867 121.074 259.737 121.725C259.607 122.376 259.287 122.974 258.818 123.443C258.348 123.912 257.75 124.231 257.099 124.36C256.448 124.49 255.773 124.423 255.16 124.168C254.547 123.914 254.023 123.483 253.655 122.931ZM254.351 119.663C254.074 120.078 253.926 120.566 253.926 121.065C253.926 121.735 254.192 122.377 254.665 122.85C255.139 123.324 255.781 123.59 256.45 123.59C256.95 123.59 257.438 123.441 257.853 123.164C258.268 122.887 258.591 122.493 258.782 122.031C258.974 121.57 259.024 121.062 258.926 120.573C258.829 120.083 258.588 119.633 258.235 119.28C257.882 118.927 257.432 118.687 256.943 118.589C256.453 118.492 255.946 118.542 255.484 118.733C255.023 118.924 254.629 119.248 254.351 119.663Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.11 129.325V131.143H244.858V129.325H245.11Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.734 129.325V131.143H246.481V129.325H246.734Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.522 129.325V131.143H243.27V129.325H243.522Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1229-inside-13_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.623 130.564H261.981V126.762H261.623V130.564Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M261.623 130.564H261.981V126.762H261.623V130.564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.981 130.564V130.953H262.369V130.564H261.981ZM261.623 130.564H261.235V130.953H261.623V130.564ZM261.623 126.762V126.374H261.235V126.762H261.623ZM261.981 126.762H262.369V126.374H261.981V126.762ZM261.981 130.176H261.623V130.953H261.981V130.176ZM262.012 130.564V126.762H261.235V130.564H262.012ZM261.623 127.151H261.981V126.374H261.623V127.151ZM261.592 126.762V130.564H262.369V126.762H261.592Z",
    fill: "#C9C5C5",
    mask: "url(#path-1229-inside-13_1_638)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1231-inside-14_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.241 130.564H260.598V126.762H260.241V130.564Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M260.241 130.564H260.598V126.762H260.241V130.564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.598 130.564V130.953H260.986V130.564H260.598ZM260.241 130.564H259.852V130.953H260.241V130.564ZM260.241 126.762V126.374H259.852V126.762H260.241ZM260.598 126.762H260.986V126.374H260.598V126.762ZM260.598 130.176H260.241V130.953H260.598V130.176ZM260.629 130.564V126.762H259.852V130.564H260.629ZM260.241 127.151H260.598V126.374H260.241V127.151ZM260.21 126.762V130.564H260.986V126.762H260.21Z",
    fill: "#C9C5C5",
    mask: "url(#path-1231-inside-14_1_638)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1233-inside-15_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.835 130.564H259.192V126.762H258.835V130.564Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M258.835 130.564H259.192V126.762H258.835V130.564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.192 130.564V130.953H259.58V130.564H259.192ZM258.835 130.564H258.446V130.953H258.835V130.564ZM258.835 126.762V126.374H258.446V126.762H258.835ZM259.192 126.762H259.58V126.374H259.192V126.762ZM259.192 130.176H258.835V130.953H259.192V130.176ZM259.223 130.564V126.762H258.446V130.564H259.223ZM258.835 127.151H259.192V126.374H258.835V127.151ZM258.804 126.762V130.564H259.58V126.762H258.804Z",
    fill: "#C9C5C5",
    mask: "url(#path-1233-inside-15_1_638)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1235-inside-16_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.623 125.757H261.981V121.955H261.623V125.757Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M261.623 125.757H261.981V121.955H261.623V125.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.981 125.757V126.145H262.369V125.757H261.981ZM261.623 125.757H261.235V126.145H261.623V125.757ZM261.623 121.955V121.566H261.235V121.955H261.623ZM261.981 121.955H262.369V121.566H261.981V121.955ZM261.981 125.368H261.623V126.145H261.981V125.368ZM262.012 125.757V121.955H261.235V125.757H262.012ZM261.623 122.343H261.981V121.566H261.623V122.343ZM261.592 121.955V125.757H262.369V121.955H261.592Z",
    fill: "#C9C5C5",
    mask: "url(#path-1235-inside-16_1_638)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1237-inside-17_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.241 125.757H260.598V121.955H260.241V125.757Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M260.241 125.757H260.598V121.955H260.241V125.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.598 125.757V126.145H260.986V125.757H260.598ZM260.241 125.757H259.852V126.145H260.241V125.757ZM260.241 121.955V121.566H259.852V121.955H260.241ZM260.598 121.955H260.986V121.566H260.598V121.955ZM260.598 125.368H260.241V126.145H260.598V125.368ZM260.629 125.757V121.955H259.852V125.757H260.629ZM260.241 122.343H260.598V121.566H260.241V122.343ZM260.21 121.955V125.757H260.986V121.955H260.21Z",
    fill: "#C9C5C5",
    mask: "url(#path-1237-inside-17_1_638)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1239-inside-18_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.246 126.762H250.889V130.564H251.246V126.762Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M251.246 126.762H250.889V130.564H251.246V126.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.889 126.762V126.374H250.501V126.762H250.889ZM251.246 126.762H251.635V126.374H251.246V126.762ZM251.246 130.564V130.953H251.635V130.564H251.246ZM250.889 130.564H250.501V130.953H250.889V130.564ZM250.889 127.151H251.246V126.374H250.889V127.151ZM250.858 126.762V130.564H251.635V126.762H250.858ZM251.246 130.176H250.889V130.953H251.246V130.176ZM251.278 130.564V126.762H250.501V130.564H251.278Z",
    fill: "#C9C5C5",
    mask: "url(#path-1239-inside-18_1_638)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1241-inside-19_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.633 126.762H252.276V130.564H252.633V126.762Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.633 126.762H252.276V130.564H252.633V126.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.276 126.762V126.374H251.887V126.762H252.276ZM252.633 126.762H253.021V126.374H252.633V126.762ZM252.633 130.564V130.953H253.021V130.564H252.633ZM252.276 130.564H251.887V130.953H252.276V130.564ZM252.276 127.151H252.633V126.374H252.276V127.151ZM252.245 126.762V130.564H253.021V126.762H252.245ZM252.633 130.176H252.276V130.953H252.633V130.176ZM252.664 130.564V126.762H251.887V130.564H252.664Z",
    fill: "#C9C5C5",
    mask: "url(#path-1241-inside-19_1_638)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1243-inside-20_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.039 126.762H253.681V130.564H254.039V126.762Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.039 126.762H253.681V130.564H254.039V126.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.681 126.762V126.374H253.293V126.762H253.681ZM254.039 126.762H254.427V126.374H254.039V126.762ZM254.039 130.564V130.953H254.427V130.564H254.039ZM253.681 130.564H253.293V130.953H253.681V130.564ZM253.681 127.151H254.039V126.374H253.681V127.151ZM253.65 126.762V130.564H254.427V126.762H253.65ZM254.039 130.176H253.681V130.953H254.039V130.176ZM254.07 130.564V126.762H253.293V130.564H254.07Z",
    fill: "#C9C5C5",
    mask: "url(#path-1243-inside-20_1_638)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1245-inside-21_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.246 121.955H250.889V125.757H251.246V121.955Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M251.246 121.955H250.889V125.757H251.246V121.955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.889 121.955V121.566H250.501V121.955H250.889ZM251.246 121.955H251.635V121.566H251.246V121.955ZM251.246 125.757V126.145H251.635V125.757H251.246ZM250.889 125.757H250.501V126.145H250.889V125.757ZM250.889 122.343H251.246V121.566H250.889V122.343ZM250.858 121.955V125.757H251.635V121.955H250.858ZM251.246 125.368H250.889V126.145H251.246V125.368ZM251.278 125.757V121.955H250.501V125.757H251.278Z",
    fill: "#C9C5C5",
    mask: "url(#path-1245-inside-21_1_638)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1247-inside-22_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.633 121.955H252.276V125.757H252.633V121.955Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.633 121.955H252.276V125.757H252.633V121.955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.276 121.955V121.566H251.887V121.955H252.276ZM252.633 121.955H253.021V121.566H252.633V121.955ZM252.633 125.757V126.145H253.021V125.757H252.633ZM252.276 125.757H251.887V126.145H252.276V125.757ZM252.276 122.343H252.633V121.566H252.276V122.343ZM252.245 121.955V125.757H253.021V121.955H252.245ZM252.633 125.368H252.276V126.145H252.633V125.368ZM252.664 125.757V121.955H251.887V125.757H252.664Z",
    fill: "#C9C5C5",
    mask: "url(#path-1247-inside-22_1_638)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.718 126.957V130.37H256.291V126.957H256.718Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.176 134.199V132.686L239.433 131.146V134.199H237.176Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.538 132.778H267.494L265.914 134.199H263.538V132.778Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.623 111.795V114.366H257.301V111.795H257.623Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.635 111.795V114.366H255.312V111.795H255.635Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.563 106.797V108.584H256.431V106.797H256.563Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.617 120.953V124.568H243.433V120.953H246.617Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.732 117.489V119.788H244.314V117.489H245.732Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.791 125.279L249.468 126.087H240.532L240.265 125.279H249.791Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.233 116.292L245.816 117.1H244.242L243.825 116.292H246.233Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.237 104.626L257.674 105.43H255.224L254.663 104.626H258.237Z",
    fill: "#88898D",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1260-inside-23_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.369 126.999H249.6V126.634H240.369V126.999Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M240.369 126.999H249.6V126.634H240.369V126.999Z",
    fill: "#88898D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.6 126.999V127.388H249.988V126.999H249.6ZM240.369 126.999H239.98V127.388H240.369V126.999ZM240.369 126.634V126.246H239.98V126.634H240.369ZM249.6 126.634H249.988V126.246H249.6V126.634ZM249.6 126.611H240.369V127.388H249.6V126.611ZM240.757 126.999V126.634H239.98V126.999H240.757ZM240.369 127.023H249.6V126.246H240.369V127.023ZM249.211 126.634V126.999H249.988V126.634H249.211Z",
    fill: "#C9C5C5",
    mask: "url(#path-1260-inside-23_1_638)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.759 121.923V123.551H245.662V121.923H245.759Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.411 121.923V123.551H244.314V121.923H244.411Z",
    fill: "white",
    stroke: "#C9C5C5",
    strokeWidth: 0.388354
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1264-inside-24_1_638",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.881 119.438H245.239V117.958H244.881V119.438Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M244.881 119.438H245.239V117.958H244.881V119.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.239 119.438V119.826H245.627V119.438H245.239ZM244.881 119.438H244.493V119.826H244.881V119.438ZM244.881 117.958V117.57H244.493V117.958H244.881ZM245.239 117.958H245.627V117.57H245.239V117.958ZM245.239 119.05H244.881V119.826H245.239V119.05ZM245.27 119.438V117.958H244.493V119.438H245.27ZM244.881 118.347H245.239V117.57H244.881V118.347ZM244.85 117.958V119.438H245.627V117.958H244.85Z",
    fill: "#C9C5C5",
    mask: "url(#path-1264-inside-24_1_638)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_638",
    x: 350.648,
    y: 200.412,
    width: 8.58487,
    height: 13.0253,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.18412,
    result: "effect1_foregroundBlur_1_638"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1_638",
    x: -0.148016,
    y: 199.82,
    width: 9.17695,
    height: 14.2095,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.48015,
    result: "effect1_foregroundBlur_1_638"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_638",
    x1: 179.986,
    y1: 202.781,
    x2: 179.986,
    y2: 215.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAFB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192522,
    stopColor: "#AFB0B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376094,
    stopColor: "#AFB0B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#7D7E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#696A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852125,
    stopColor: "#838489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931356,
    stopColor: "#ABACB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_638",
    x1: 316.604,
    y1: 216.472,
    x2: 340.139,
    y2: 216.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173014,
    stopColor: "#525358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31824,
    stopColor: "#78797D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465029,
    stopColor: "#A0A0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691458,
    stopColor: "#9A9A9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825754,
    stopColor: "#4F5055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941311,
    stopColor: "#9E9EA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#848589"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_638",
    x1: 317.505,
    y1: 216.953,
    x2: 339.229,
    y2: 216.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0827846,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490477,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824814,
    stopColor: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C5C5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_638",
    x1: 19.538,
    y1: 216.472,
    x2: 43.0724,
    y2: 216.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173014,
    stopColor: "#525358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31824,
    stopColor: "#78797D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465029,
    stopColor: "#A0A0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691458,
    stopColor: "#9A9A9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825754,
    stopColor: "#4F5055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941311,
    stopColor: "#9E9EA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#848589"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_638",
    x1: 20.4383,
    y1: 216.953,
    x2: 42.1629,
    y2: 216.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0827846,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490477,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824814,
    stopColor: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C5C5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_638",
    x1: 148.755,
    y1: 205.149,
    x2: 211.218,
    y2: 205.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25262B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015659,
    stopColor: "#606166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035819,
    stopColor: "#9FA0A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0504351,
    stopColor: "#C8C8CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#D7D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941214,
    stopColor: "#CBCBD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970403,
    stopColor: "#A7A8AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980129,
    stopColor: "#595A5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27282C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_638",
    x1: 355.976,
    y1: 207.813,
    x2: 331.998,
    y2: 207.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65666B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259918,
    stopColor: "#65666B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65666B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_638",
    x1: 24.8665,
    y1: 5.03251,
    x2: 8.51129e-9,
    y2: 5.03251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65666B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259918,
    stopColor: "#65666B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65666B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_638",
    x1: 179.838,
    y1: 194.492,
    x2: 179.838,
    y2: 201.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0852114,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830431,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201F24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 359.973,
    height: 217.434,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 359.973,
    height: 14.6535,
    fill: "white",
    transform: "translate(0 202.781)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1_638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 162.013,
    fill: "white",
    transform: "translate(91 20)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterMobileFullMacbook);
export default __webpack_public_path__ + "static/media/center-mobile-full-macbook.ea312ba8fb1404c6d3f65e9d644f27b3.svg";
export { ForwardRef as ReactComponent };